/* tslint:disable */
export const localFr = {
  'LANG_DE': 'Allemand',
  'LANG_EN': 'Anglais',
  'LANG_ES': 'Espagnol',
  'LANG_FR': 'Français',
  'LANG_IT': 'Italien',
  'LANG_NL': 'Neerlandais',
  'MONDAY': 'Lundi',
  'TUESDAY': 'Mardi',
  'WEDNESDAY': 'Mercredi',
  'THURSDAY': 'Jeudi',
  'FRIDAY': 'Vendredi',
  'SATURDAY': 'Samedi',
  'SUNDAY': 'Dimanche',
  'PRINT': 'Imprimer',
  'CHART': 'Graphique',
  'IMPERSONATE_USER': 'Prendre l\'identité',
  'LEAVE_IMPERSONATION': 'Quitter l\'identité',
  'MY_PROFILE': 'Mon Profile',
  'LOGOUT': 'Déconnexion',
  'RUN_AS': 'en tant que',
  'CLOSE': 'Fermer',
  'BLOCKED': 'Bloqué',
  'AUTHORIZED': 'Autorisé',
  'LIMITED': 'Limité',
  'RESTRICTION_PLANNING': 'Planning de mise à jour',
  'IMPERSONATE_DIALOG': 'Liste des utilisateurs',
  'IMPERSONATE_DIALOG_TITLE': 'Utilisateurs',
  'IMPERSONATE_DIALOG_EXPLAIN_P1':
    'Avec cette fonctionnalité vous pouvez naviguer dans le Portail en utilisant le login d\'un autre utilisateurs. Cette fonction n\'est posssible que pour un administrateur.',
  'IMPERSONATE_DIALOG_EXPLAIN_P2':
    'Toutes les actions faites "en tant" qu\'un autre utilisateur sont toutefois enregistrées dans le système sous votre nom d\'utilisateur.',
  'SHOW_X_ELEMENTS_START': 'Afficher',
  'SHOW_X_ELEMENTS_END': 'éléments',
  'SEARCH': 'Rechercher',
  'NAME': 'Nom',
  'EMAIL': 'Email',
  'ROLES_GROUP': 'Groupe de rôles',
  'IMPERSONATE': 'En tant que...',
  'CANCEL': 'Annuler',
  'PAGINATION_INFO': 'Affiche {{from}} à {{to}} sur {{filteredLength}} éléments',
  'FILTERED_PAGINATION_INFO': 'Affiche {{from}} à {{to}} sur {{filteredLength}} éléments (filtré sur un total de {{totalLength}} éléments)',
  'CLIENT_SELECTOR_PLACEHOLDER': 'Changer de client...',
  'DASHBOARD': 'Dashboard',
  'USERS': 'Utilisateurs',
  'CREATED': 'Créer',
  'UPDATED': 'Mis-à-jour',
  'LASTRUN': 'Last run',
  'FREQUENCY': 'Fréquence',
  'DAILY': 'Tous les jours',
  'WEEKLY': '1er jour de la semaine',
  'MONTHLY': '1er jour du mois',
  'All': 'Tous',
  'SERVICES': 'Services',
  'ACTIVE': 'Actif',
  'DELETE': 'Supprimer',
  'SEND': 'Tester',
  'FILTERED': 'Filtrer',
  'NOT_FILTERED': 'Tout',
  'EXCEL_DATA': 'Export Excel',
  'MY_PROFILE_TITLE': 'Mon profile',
  'MY_PROFILE_PERSONAL_INFO': 'Mes informations',
  'MY_PROFILE_CHANGE_AVATAR': 'Changer mon avatar',
  'MY_PROFILE_CHANGE_PASSWORD': 'Changer mon mot de passe',
  'MY_PROFILE_IDENTITIES': 'Mes comptes tiers',
  'MY_PROFILE_USER_NAME': 'Nom',
  'MY_PROFILE_USER_NAME_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_NAME_REQUIRED': 'Vous devez indiquer votre nom.',
  'MY_PROFILE_USER_EMAIL': 'Email',
  'MY_PROFILE_USER_EMAIL_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_EMAIL_REQUIRED': 'Vous devez indiquer votre e-mail.',
  'MY_PROFILE_USER_EMAIL_INVALID': 'Votre e-mail n\'est pas valide.',
  'MY_PROFILE_USER_CULTURE': 'Culture',
  'MY_PROFILE_USER_CULTURE_REQUIRED': 'Vous devez sélectionner votre culture.',
  'MY_PROFILE_USER_GENDER': 'Genre',
  'MY_PROFILE_USER_TIMEZONE': 'Fuseau horaire',
  'MY_PROFILE_USER_TIMEZONE_REQUIRED': 'Vous devez sélectionner votre fuseau horaire.',
  'MY_PROFILE_USER_PHONE': 'Téléphone',
  'MY_PROFILE_USER_PHONE_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_FAX': 'Fax',
  'MY_PROFILE_USER_FAX_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_MOBILE': 'Mobile',
  'MY_PROFILE_USER_MOBILE_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_SKYPE': 'Skype',
  'MY_PROFILE_USER_SKYPE_PLACEHOLDER': ' ',
  'MY_PROFILE_USER_DEPARTMENT': 'Departement',
  'MY_PROFILE_USER_DEPARTMENT_PLACEHOLDER': ' ',
  'MY_PROFILE_UNSAVED_CHANGES_START': 'Vous n\'avez pas sauvegardé vos changements dans le(s) onglet(s) suivant(s):',
  'MY_PROFILE_UNSAVED_CHANGES_END': 'Etes vous sure de vouloir quitter cette page sans sauvegarder vos changements ?',
  'GENDER_UNDEFINED': ' ',
  'GENDER_WOMAN': 'Femme',
  'GENDER_MAN': 'Homme',
  'SAVE_CHANGES': 'Sauver',
  'SAVING_CHANGES': 'Sauvegarde en cours...',
  'EXTERNAL_ID_LINK': 'Associé',
  'EXTERNAL_ID_UNLINK': 'Dissocié',
  'EXTERNAL_ID_GOOGLE': 'Associer votre compte Google®.',
  'EXTERNAL_ID_MSLIVE': 'Associer votre compte Microsoft Live®',
  'CHANGE_PASSWORD_STRENGTH': 'Niveau de sécurité du mot de passe',
  'PASSWORD_STRENGTH_VERY_WEAK': 'Très faible',
  'PASSWORD_STRENGTH_VERY_WEAK_DESC': 'Résiste pendant quelques minutes à un attaquant typique.',
  'PASSWORD_STRENGTH_WEAK': 'Faible',
  'PASSWORD_STRENGTH_WEAK_DESC': 'Craquable par un ordinateur personnel en une semaine.',
  'PASSWORD_STRENGTH_REASONABLE': 'Raisonnable',
  'PASSWORD_STRENGTH_REASONABLE_DESC': 'Un ordinateur spécialisé pourrait l\'obtenir en an environ.',
  'PASSWORD_STRENGTH_STRONG': 'Fort',
  'PASSWORD_STRENGTH_STRONG_DESC': 'Résistant à une grande attaque coordonnée (botnet) pendant plus d\'un an.',
  'PASSWORD_STRENGTH_VERY_STRONG': 'Très fort',
  'PASSWORD_STRENGTH_VERY_STRONG_DESC':
    'Presque impossible à craquer, en comptant toute la puissance informatique du monde, avec des algorithmes optimisés et du materiel spécialisé et mille ans.',
  'CHANGE_PASSWORD_CURRENT': 'Mot de passe actuel',
  'CHANGE_PASSWORD_CURRENT_REQUIRED': 'Le Mot de passe actuel est nécessaire.',
  'CHANGE_PASSWORD_NEW': 'Nouveau mot de passe',
  'CHANGE_PASSWORD_NEW_REQUIRED': 'Le nouveau mot de passe est nécessaire.',
  'CHANGE_PASSWORD_NEW_MINLENGTH': 'Le nouveau mot de passe doit contenir au moins 4 caractères.',
  'CHANGE_PASSWORD_NEW_MUST_BE_DIFFERENT': 'Le nouveau mot de passe doit être différent de l\'actuel mot de passe.',
  'CHANGE_PASSWORD_VALIDATION_ERROR_ME': 'Une erreur de validation s\'est produite lors du changement de votre mot de passe.',
  'CHANGE_PASSWORD_CONFIRM': 'Confirmer votre nouveau mot de passe.',
  'CHANGE_PASSWORD_CONFIRM_MISMATCH': 'Le mot de passe et sa confirmation ne sont pas identiques!',
  'CHANGE_PASSWORD_SAVE': 'Sauver le mot de passe',
  'CHANGE_PASSWORD_SAVING': 'Sauvegarde du mot de passe...',
  'CHANGE_AVATAR_YOURS': 'Votre avatar',
  'CHANGE_AVATAR_SELECT': 'Sélectionner une image',
  'CHANGE_AVATAR_CHANGE': 'Changer',
  'CHANGE_AVATAR_REMOVE': 'Supprimer',
  'CHANGE_AVATAR_SAVE': 'Valider',
  'CHANGE_AVATAR_SAVING': 'Validation...',
  'ASSIGN_GROUP_DIALOG': 'Assignation d\'utilisateur à un groupe de rôles',
  'ASSIGN_GROUP_DIALOG_TITLE': 'Associer utilisateur(s) au groupe',
  'ASSIGN_GROUP_DIALOG_SINGLE': 'Associer cet utilisateur à un groupe de rôles.',
  'ASSIGN_GROUP_DIALOG_MULTI': 'Associer ces utilisateurs à un groupe de rôles.',
  'ASSIGN_GROUP_DIALOG_GROUP': 'Groupe:',
  'ASSIGN_GROUP_DIALOG_NOSELECTION': '(sélectionner un groupe)',
  'ASSIGN_GROUP_DIALOG_ACCEPT': 'Associer',
  'AUTH0_INFO_TITLE': 'Information de connexion',
  'AUTH0_INFO_HISTORY': 'Historique',
  'AUTH0_INFO_MAP': 'Locatisation',
  'AUTH0_LOGS_DURATION': 'Durée max. des Logs: 10 jours.',
  'AUTH0_LOGS_EVENT': 'Evènement',
  'AUTH0_LOGS_WHEN': 'Quand',
  'AUTH0_LOGS_APP': 'Application',
  'AUTH0_LOGS_IDP': 'Fournisseur d\'identité',
  'AUTH0_LOGS_IP': 'Adresse IP',
  'AUTH0_LOGS_FROM': 'De',
  'AUTH0_MAP_SUCCESS_LOGIN': 'Accès autorisé',
  'CONFIRM_DELETE_USERS_DIALOG': 'Confirmation de suppression d\'utilisateur',
  'CONFIRM_DELETE_USERS_DIALOG_TITLE': 'Confirmation de supression',
  'CONFIRM_DELETE_USERS_DIALOG_SINGLE': 'Etes-vous certain de vouloir supprimer cet utilisateur ?',
  'CONFIRM_DELETE_USERS_DIALOG_MULTI': 'Etes-vous certain de vouloir supprimer ces utilisateurs ?',
  'CONFIRM_DELETE_USERS_DIALOG_ACCEPT': 'Supprimer',
  'CREATE_USER_DIALOG': 'Création d\'un nouvel utilisateur',
  'CREATE_USER_DIALOG_TITLE': 'Créer un utilisateur',
  'CREATE_USER_DIALOG_ACCEPT': 'Créer',
  'CREATE_USER_DIALOG_NAME': 'Nom',
  'CREATE_USER_DIALOG_NAME_PLACEHOLDER': ' ',
  'CREATE_USER_DIALOG_NAME_REQUIRED': 'Le nom de l\'utiisateur est nécessaire.',
  'CREATE_USER_DIALOG_EMAIL': 'Email',
  'CREATE_USER_DIALOG_EMAIL_PLACEHOLDER': ' ',
  'CREATE_USER_DIALOG_EMAIL_REQUIRED': 'L\'email est nécessaire.',
  'CREATE_USER_DIALOG_EMAIL_INVALID': 'L\'email n\'est pas valide.',
  'CREATE_USER_DIALOG_ROLES_GROUP': 'Groupe de rôles',
  'CREATE_USER_DIALOG_ROLES_GROUP_NONE': ' ',
  'CREATE_USER_DIALOG_ROLES_GROUP_REQUIRED': 'Le groupe de rôles est nécessaire.',
  'CREATE_USER_DIALOG_OFFICE': 'Bureaux',
  'CREATE_USER_DUPLICATE': 'L\'utilisateur existe déjà. Vous êtes redirigé vers l\'utilisateur existant.',
  'OFFICE_NONE': ' ',
  'OFFICE_BE': 'Belgique',
  'OFFICE_FR': 'France',
  'OFFICE_ES': 'Espagne',
  'OFFICE_DE': 'Allemange',
  'OFFICE_CN': 'Chine',
  'OFFICE_IT': 'MCube Italie',
  'EDIT_USER_NAME': 'Nom',
  'EDIT_USER_NAME_PLACEHOLDER': ' ',
  'EDIT_USER_NAME_REQUIRED': 'Le nom de l\'utilisateur est nécessaire.',
  'EDIT_USER_EMAIL': 'Email',
  'EDIT_USER_EMAIL_PLACEHOLDER': ' ',
  'EDIT_USER_EMAIL_REQUIRED': 'L\'e-mail est nécessaire.',
  'EDIT_USER_EMAIL_INVALID': 'L\'e-mail n\'est pas valide.',
  'EDIT_USER_ROLES_GROUP': 'Groupe de rôles',
  'EDIT_USER_ROLES_GROUP_NONE': ' ',
  'EDIT_USER_ROLES_GROUP_REQUIRED': 'Le groupe de rôles est nécessaire.',
  'EDIT_USER_OFFICE': 'Bureau',
  'EDIT_USER_CULTURE': 'Culture',
  'EDIT_USER_CULTURE_REQUIRED': 'La culture est nécessaire.',
  'EDIT_USER_GENDER': 'Genre',
  'EDIT_USER_TIMEZONE': 'Fuseau horaire',
  'EDIT_USER_TIMEZONE_REQUIRED': 'Le fuseau horaire est nécessaire.',
  'EDIT_USER_PHONE': 'Téléphone',
  'EDIT_USER_PHONE_PLACEHOLDER': ' ',
  'EDIT_USER_FAX': 'Fax',
  'EDIT_USER_FAX_PLACEHOLDER': ' ',
  'EDIT_USER_MOBILE': 'Mobile',
  'EDIT_USER_MOBILE_PLACEHOLDER': ' ',
  'EDIT_USER_SKYPE': 'Skype',
  'EDIT_USER_SKYPE_PLACEHOLDER': ' ',
  'EDIT_USER_DEPARTMENT': 'Département',
  'EDIT_USER_DEPARTMENT_PLACEHOLDER': ' ',
  'IMPORT_USERS_DIALOG': 'Importation d\'utilisateurs depuis un autre client',
  'IMPORT_USERS_DIALOG_TITLE': 'Importer utilisateur(s)',
  'IMPORT_USERS_DIALOG_CLIENT': 'Client:',
  'IMPORT_USERS_DIALOG_CLIENT_NONE': '(sélectionner un client)',
  'IMPORT_USERS_DIALOG_USER': 'Utilisateur:',
  'IMPORT_USERS_DIALOG_ROLES_GROUP': 'Groupe de rôles:',
  'IMPORT_USERS_DIALOG_ROLES_GROUP_NONE': '(sélectionner un groupe)',
  'IMPORT_USERS_DIALOG_ACCEPT': 'Importer',
  'USERS_LIST_TITLE': 'Utilisateur',
  'USERS_LIST_CREATE': 'Créer',
  'USERS_LIST_IMPORT': 'Importer',
  'USERS_LIST_FILTER': 'Filtrer',
  'USERS_LIST_QUICK_SEARCH': 'Recherche par nom',
  'EXPANDER_TITLE': 'Etendre/Fermer',
  'USERS_LIST_FILTER_NAME': 'Nom',
  'USERS_LIST_FILTER_EMAIL': 'Email',
  'USERS_LIST_FILTER_ACTIVE': 'Actif',
  'USERS_LIST_FILTER_ACTIVE_ALL': ' ',
  'YES': 'Oui',
  'NO': 'Non',
  'USERS_LIST_FILTER_ROLES_GROUP': 'Groupe de rôles',
  'USERS_LIST_FILTER_ROLES_GROUP_ALL': ' ',
  'USERS_LIST_FILTER_SEARCH': 'Rechercher',
  'USERS_LIST_FILTER_RESET': 'Réinitialiser',
  'USERS_LIST_SELECT_PAGE': 'Sélectionner une page',
  'USERS_LIST_UNSELECT_PAGE': 'Désélectionner une page',
  'USERS_LIST_ACTIONS': 'Actions',
  'USERS_LIST_TOGGLE_STATUS': 'Basculer le statut',
  'USERS_LIST_ASSIGN_ROLES_GROUP': 'Associer un groupe de rôles',
  'USERS_LIST_LINK_AUDIO_PLAYERS': 'Associer à un ou des Player(s) Audio',
  'USERS_LIST_UNLINK_AUDIO_PLAYERS': 'Dissocier un ou des Player(s) Audio',
  'USERS_LIST_LINK_VIDEO_PLAYERS': 'Associer à un ou des Player(s) Vidéo',
  'USERS_LIST_UNLINK_VIDEO_PLAYERS': 'Dissocier un ou des Player(s) Vidéo',
  'USERS_LIST_DELETE': 'Supprimer',
  'USERS_LIST_COLUMN_AVATAR': 'Avatar',
  'USERS_LIST_COLUMN_NAME': 'Nom',
  'USERS_LIST_COLUMN_EMAIL': 'Email',
  'USERS_LIST_COLUMN_ROLES_GROUP': 'Groupe de rôles',
  'USERS_LIST_COLUMN_NUMBER_AUDIO': '# Audios',
  'USERS_LIST_COLUMN_NUMBER_VIDEO': '# Vidéos',
  'USERS_LIST_COLUMN_STATUS': 'Statut',
  'USER_NOT_FOUND': 'L\'utilisateur n\'existe pas...',
  'USER_SIDEBAR_BLOCK': 'Bloquer l\'utilisateur',
  'USER_SIDEBAR_UNBLOCK': 'Débloquer l\'utilisateur',
  'USER_SIDEBAR_DELETE': 'Supprimer',
  'USER_SIDEBAR_RESET_PASSWORD': 'Réinitialiser le mot de passe',
  'USER_SIDEBAR_USER_INFO': 'Informations utilisateur',
  'USER_SIDEBAR_SUBSCRIPTION_INFO': 'Informations de l\'abonnement',
  'USER_SIDEBAR_CONNECTION_INFO': 'Informations de connexion',
  'USER_SUBSCRIPTIONS_ASSIGN_ALL': 'Associer tous les players (également les nouveaux qui seront ajoutés plus tard).',
  'USER_SUBSCRIPTIONS_IMPORT': 'Importer des players depuis un autre utilisateur',
  'USER_SUBSCRIPTIONS_ASSIGNED': 'Players associés',
  'USER_SUBSCRIPTIONS_ASSIGNED_TEXT': 'Déplacer un player dissocié pour l\'associer à l\'utilisateur.',
  'USER_SUBSCRIPTIONS_ASSIGNED_FILTER': 'Filter les players associés',
  'USER_SUBSCRIPTIONS_ASSIGNED_EMPTY': 'L\'utilisateur n\'a accès à aucun player.',
  'USER_SUBSCRIPTIONS_ASSIGNED_TOGGLE': 'Dissocier tous les players',
  'USER_SUBSCRIPTIONS_UNASSIGNED': 'Players dissociés',
  'USER_SUBSCRIPTIONS_UNASSIGNED_TEXT': 'Déplacer un player associé pour le dissocier de l\'utilisateur.',
  'USER_SUBSCRIPTIONS_UNASSIGNED_FILTER': 'Filter les players dissociés',
  'USER_SUBSCRIPTIONS_UNASSIGNED_EMPTY': 'L\'utilisateur a accès à tous les players.',
  'USER_SUBSCRIPTIONS_UNASSIGNED_TOGGLE': 'Associer tous les players',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG': 'Importer des players depuis un autre utilisateur',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_TITLE': 'Importer des players depuis un autre utilisateur',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_USER': 'Sélectionner l\'utilisateur depuis lequel les players seront importés.',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_USER_NONE': '-- Sélectionner un utilisateur --',
  'USER_SUBSCRIPTIONS_IMPORT_DIALOG_ACCEPT': 'Importer',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG': 'Associer des utilisateurs à {{type}} players.',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG': 'Dissocier des utilisateurs de {{type}} players.',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG_TITLE': 'Associer de {{type}} players',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_TITLE': 'Dissocier de {{type}} players',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG_SINGLE': 'Sélectionner le(s) player(s) que vous voulez associer à cet utilisateur.',
  'USERS_LINK_SUBSCRIPTIONS_DIALOG_MULTI': 'Sélectionner le(s) player(s) que vous voulez associer de ces utilisateurs.',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_SINGLE': 'Sélectionner le(s) player(s) que vous voulez dissocier à cet utilisateur.',
  'USERS_UNLINK_SUBSCRIPTIONS_DIALOG_MULTI': 'Sélectionner le(s) player(s) que vous voulez dissocier de ces utilisateurs.',
  'USERS_UN_LINK_SUBSCRIPTIONS_USERS': 'Utilisateurs',
  'USERS_UN_LINK_SUBSCRIPTIONS_PLAYERS': 'Players',
  'USERS_UN_LINK_SUBSCRIPTIONS_SELECT_ALL': 'Tout sélectionner',
  'USERS_UN_LINK_SUBSCRIPTIONS_SELECT_NONE': 'Ne rien sélectionner',
  'USERS_UN_LINK_SUBSCRIPTIONS_LINK': 'Associer',
  'USERS_UN_LINK_SUBSCRIPTIONS_UNLINK': 'Dissocier',
  'USER_INFO_TITLE': 'Informations utilisateur',
  'USER_INFO_PERSONAL_INFO': 'Informations personnelles',
  'USER_INFO_AVATAR': 'Changer Avatar',
  'USER_INFO_AUDIO_PLAYERS': 'Audio Players',
  'USER_INFO_VIDEO_PLAYERS': 'Vidéo Players',
  'USER_INFO_UNSAVED_CHANGES_START': 'Etes-vous sure de vouloir quitter cette page sans sauvegarder vos changements dans le ou les onglet(s):',
  'USER_INFO_UNSAVED_CHANGES_END': 'Etes-vous sure de vouloir quitter cette page sans sauvegarder vos changements ?',
  'TOAST_ERROR_TITLE': 'Erreur',
  'TOAST_SUCCESS_TITLE': 'Succes',
  'TOAST_INFO_TITLE': 'Information',
  'TOAST_WARNING_TITLE': 'Attention',
  'TOAST_ACCESS_DENIED_TITLE': 'Accès interdit',
  'GROUP_ROLES_LOAD_ERROR': 'Une erreur est survenue dans le chargement du groupe de rôles pour le client en cours.',
  'GROUP_ROLES_TEMPLATES_LOAD_ERROR': 'Une erreur est survenue dans le chargement du groupe de rôles templates pour le client en cours',
  'CULTURES_LOAD_ERROR': 'Une erreur est survenue au chargement des cultures.',
  'OFFICES_LOAD_ERROR': 'Une erreur est survenue au chargement des offices.',
  'MY_CLIENTS_LOAD_ERROR': 'Impossible de charger la list de vos clients.',
  'SUBSCRIPTIONS_LIST_LOAD_AUDIO_ERROR': 'Une erreur est survenue dans le chargement des abonnements audio pour le client en cours.',
  'SUBSCRIPTIONS_LIST_LOAD_VIDEO_ERROR': 'Une erreur est survenue dans le chargement des abonnements vidéo pour le client en cours.',
  'TIMEZONES_LOAD_ERROR': 'Une erreur est survenue dans le chargement des fuseaux horaires.',
  'USER_LOAD_ERROR_ME': 'Une erreur est survenue dans le chargement de votre profile.',
  'USER_LOAD_ERROR': 'Une erreur est survenue dans le chargement des informations utilisateur.',
  'USER_SAVE_SUCCESS_ME': 'Votre profile a été correctement sauvegardé.',
  'USER_SAVE_SUCCESS': 'Les informations utilisateur ont été correctement sauvegardées.',
  'USER_SAVE_ERROR_ME': 'Une erreur est survenue dans la sauvegarde de votre profile.',
  'USER_SAVE_VALIDATION_ERROR_ME': 'Une erreur de validation est survenue dans la sauvegarde de votre profile.',
  'USER_SAVE_ERROR': 'Une erreur est survenue dans la sauvegarde des informations utilisateur.',
  'USER_SAVE_VALIDATION_ERROR': 'Une erreur de validation est survenue dans la sauvegarde des informations utilisateur.',
  'USER_CHANGE_AVATAR_SUCCESS_ME': 'Votre Avatar a été correctement modifié.',
  'USER_CHANGE_AVATAR_SUCCESS': 'L\'avatar de l\'utiisateur à été correctement modifié.',
  'USER_CHANGE_AVATAR_ERROR_ME': 'Une erreur est survenue dans la sauvegarde de votre avatar.',
  'USER_CHANGE_AVATAR_ERROR': 'Une erreur est survenue dans la sauvegarde de l\'avatar de l\'utiisateur.',
  'USER_CHANGE_PASSWORD_SUCCESS': 'Votre mot de passe a été correctement modifié.',
  'USER_CHANGE_PASSWORD_ERROR': 'Une erreur est survenue dans le changement de votre mot de passe.',
  'USER_RESET_PASSWORD_SUCCESS': 'Votre mot de passe a été correctement redéfini.',
  'USER_RESET_PASSWORD_ERROR': 'Une erreur est survenue dans le redéfinition de votre mot de passe.',
  'USER_TOGGLE_ACTIVE_SUCCESS': 'L\'utilisateur a été correctement mis à jour.',
  'USER_TOGGLE_ACTIVE_ERROR': 'Une erreur est survenue dans la mise à jour de l\'utilisateur.',
  'USER_REMOVE_SUCCESS': 'L\'utilisateur a été supprimé du client.',
  'USER_REMOVE_ERROR': 'Une erreur est survenue dans la suppression de l\'utilisateur.',
  'USER_REMOVE_SELF_ERROR': 'Vous ne pouvez pas vous supprimer vous même :-).',
  'USER_LOAD_AUDIO_SUBSCRIPTIONS_ERROR': 'Une erreur s\'est produite lors du chargement des abonnements audio de l\'utilisateur.',
  'USER_LOAD_VIDEO_SUBSCRIPTIONS_ERROR': 'Une erreur s\'est produite lors du chargement des abonnements vidéo de l\'utilisateur.',
  'USER_UPDATE_AUDIO_SUBSCRIPTIONS_SUCCESS': 'Les abonnements audio de l\'utilisateur ont été correctement modifié.',
  'USER_UPDATE_AUDIO_SUBSCRIPTIONS_ERROR': 'Une erreur s\'est produite lors de la modification des abonnements audio de l\'utilisateur.',
  'USER_UPDATE_VIDEO_SUBSCRIPTIONS_SUCCESS': 'Les abonnements vidéo de l\'utilisateur ont été correctement modifié.',
  'USER_UPDATE_VIDEO_SUBSCRIPTIONS_ERROR': 'Une erreur s\'est produite lors de la modification des abonnements vidéo de l\'utilisateur.',
  'USER_IMPORT_AUDIO_SUBSCRIPTIONS_SUCCESS': 'Les abonnements audio ont été correctement importés.',
  'USER_IMPORT_AUDIO_SUBSCRIPTIONS_ERROR': 'Une erreur s\'est produite lors de l\'importation des abonnements audio d\'un autre utilisateur.',
  'USER_IMPORT_VIDEO_SUBSCRIPTIONS_SUCCESS': 'Les abonnements vidéo ont été correctement importés.',
  'USER_IMPORT_VIDEO_SUBSCRIPTIONS_ERROR': 'Une erreur s\'est produite lors de l\'importation des abonnements vidéo d\'un autre utilisateur.',
  'USER_CONTEXT_IMPERSONATE_ACCESS_DENIED': 'Vous ne pouvez pas prendre l\'identité d\'un autre utilisateur.',
  'USER_CONTEXT_IMPERSONATE_SUCCESS':
    'Vous avez pris l\'identité de  {{username}} pour les prochaines {{duration}} minutes ou jusqu\'à ce que vous quittiez manuellement cette identité.',
  'USER_CONTEXT_IMPERSONATE_ERROR': 'Une erreur s\'est produite lors de la prise d\'identité de {{username}}.',
  'USER_CONTEXT_GET_ROLES_ERROR': 'Impossible d\'identifier vos rôles. Veuiller contacter votre administateur ou le support.',
  'USER_CONTEXT_GET_IMPERSONABLE_ERROR':
    'Impossible de retrouver la liste des identités des utilisateurs relatif à "{{clientName}}". Veuiller contacter votre administateur ou le support.',
  'USERS_LOAD_ERROR': 'Une erreur s\'est produite lors de l\'extraction des utilisateurs.',
  'USERS_LOAD_BAD_REQUEST_ERROR': 'Il y a une erreur dans les filtres de recherche.',
  'USERS_DELETE_ERROR': 'Il y avait une ou plusieurs erreur(s) dans la suppression d\'utilisateur(s).',
  'USERS_DELETE_SELF_ERROR': 'Vous ne pouvez pas vous supprimer vous même :-).',
  'USERS_DELETE_SUCCESS': 'Le ou les utilisateur(s) sélectionné(s) ont été correctement supprimé(s).',
  'USERS_REFRESH_ERROR': 'Une erreur s\'est produite lors du rafraîchissement de la liste des utilisateurs.',
  'USERS_IMPORT_ERROR': 'Une erreur s\'est produite lors de l\'importation des utilisateurs.',
  'USERS_IMPORT_BAD_REQUEST_ERROR': 'Une erreur de validation s\'est produite lors de l\'importation des utilisateurs.',
  'USERS_IMPORT_SUCCESS': 'Le ou les utilisateur(s) a (ont) été correctement importé(s).',
  'USERS_CREATE_SUCCESS': 'L\'utilisateur a été correcment créé.',
  'USERS_CREATE_ERROR': 'Une erreur s\'est produite lors de la création d\'un nouvel utilisateur.',
  'USERS_CREATE_BAD_REQUEST_ERROR': 'Une erreur de validation s\'est produite lors de la création d\'un nouvel utilisateur.',
  'USERS_PATCH_SUCCESS': 'Le(s) utilisateur(s) sélectionné(s) a (sont) été correctement mis à jour.',
  'USERS_PATCH_ERROR': 'Une erreur s\'est produite lors de la mise à jour de(s) utilisateur(s) sélectionné(s).',
  'USERS_UN_LINK_SUBSCRIPTIONS_SUCCESS': 'Le(s) utilisateur(s) sélectionné(s) a (sont) été correctement mis à jour.',
  'USERS_UN_LINK_SUBSCRIPTIONS_ERROR': 'Une erreur s\'est produite lors de la mise à jour de(s) utilisateur(s) sélectionné(s).',
  'AUTH_UNLINK_SUCCESS': 'Votre compte social a été correctement dissocié.',
  'AUTH_UNLINK_ERROR': 'Une erreur s\'est produite lors de la dissociation de votre compte social.',
  'AUTH_GET_USER_INFO_ERROR':
    'Une erreur s\'est produite lors de la récupération de vos informations utilisateur depuis le fournisseur d\'identité: [{{code}}]] {{description}}',
  'AUTH_UPDATE_PROFILE_ERROR': 'Une erreur s\'est produite lors la tentative de modification de votre profile.',
  'AUTH_LOGS_LOAD_ERROR': 'AUne erreur s\'est produite lors la récupération des logs d\'authentification de l\'utilisateur.',
  'AUTH_LINK_ERROR': 'Une erreur s\'est produite lors de l\'association de votre compte social.',
  'AUTH_LINK_ERROR_DETAILS': 'Une erreur s\'est produite lors de l\'association de votre compte social: [{{code}}] {{description}}',
  'ERROR_PAGE_NOT_FOUND': '404',
  'ERROR_PAGE_NOT_FOUND_TITLE': 'Houston, nous avons un problème.',
  'ERROR_PAGE_NOT_FOUND_PARA': 'La page que vous recherchez n\'existe pas ou plus.',
  'ERROR_PAGE_RETURN_HOME': 'Retour',
  'ERROR_PAGE_ACCESS_DENIED': '403',
  'ERROR_PAGE_ACCESS_DENIED_TITLE': 'Houston, nous avons un problème.',
  'ERROR_PAGE_ACCESS_DENIED_PARA': 'La page que vous recherchez n\'existe pas ou plus.',
  'AUTH_LOGIN_GENERIC_ERROR': 'Quelques chose ne fonctionne pas pour vous connecter... Veuillez contacter votre administateur ou le support.',
  'AUTH_LOGIN_WRONG_CREDENTIALS': 'Email ou mot de passe invalide.',
  'AUTH_LOGIN_BLOCKED': 'Votre compte est bloqué. Veuiller contacter votre administateur ou le support.',
  'AUTH_LOGIN_LEAKED': 'Votre compte a été bloqué pour votre sécurité. Veuillez contacter votre administateur ou le support.',
  'AUTH_LOGIN_SOCIAL_FIRST': 'Vous ne pouvez pas vous authentifier avec votre compte social s\'il n\'est pas associcé à un compte local existant.',
  'AUTH_LOGIN_ACCESS_DENIED': 'Acces non autorisé ! Veuiller contacter votre administateur ou le support.',
  'AUTH_LOGIN_INVALID_TOKEN': 'Token invalide:',
  'AUTH_LOGIN_AUTO_TITLE': 'Veuiller patienter...',
  'AUTH_RENEW_PASSWORD_TITLE': 'Le lien a expiré, veuillez refaire une demande.',
  'AUTH_LOST_PASSWORD_TITLE': 'Mot de Passe outblié ?',
  'AUTH_LOST_PASSWORD_PARA': 'Entrer votre email pour récupérer votre mot de passe.',
  'AUTH_LOST_PASSWORD_ERROR': 'Une erreur s\'est produite lors de l\'envoi de votre demande.',
  'AUTH_LOST_PASSWORD_SUCCESS': 'Un email vous a été envoyé avec la procédure de réinitialisation de votre mot de passe.',
  'AUTH_GOTO_LOGIN_PAGE': 'Cliquer ici pour rejoindre la page d\'authentification.',
  'AUTH_LOST_PASSWORD_EMAIL': 'Email',
  'AUTH_LOST_PASSWORD_EMAIL_REQUIRED': 'L\'email est nécessaire.',
  'AUTH_LOST_PASSWORD_EMAIL_INVALID': 'L\'email n\'est pas valide.',
  'AUTH_LOST_PASSWORD_BACK': 'Retour',
  'AUTH_LOST_PASSWORD_SUBMIT': 'Envoyez',
  'AUTH_LOST_PASSWORD_SUBMITTING': 'Envoi en cour...',
  'AUTH_RESET_PASSWORD_TITLE': 'Réinitialiser le mot de passe.',
  'AUTH_RESET_PASSWORD_PARA': 'Entrer votre nouveau mot et confirmer le une seconde fois.',
  'AUTH_RESET_PASSWORD_ERROR': 'Une erreur s\'est produite lors de l\'envoi de votre nouveau mot de passe.',
  'AUTH_RESET_PASSWORD_SUCCESS': 'Votre mot de passe a correctement été réinitialisé.',
  'AUTH_RESET_PASSWORD_NEW': 'Nouveau mot de passe.',
  'AUTH_RESET_PASSWORD_NEW_REQUIRED': 'Le nouveau mot de passe est nécessaire.',
  'AUTH_RESET_PASSWORD_NEW_MINLENGTH': 'Le nouveau mot de passe doit contenir au moins 4 charactères.',
  'AUTH_RESET_PASSWORD_CONFIRM': 'Confirmation du mot de passe.',
  'AUTH_RESET_PASSWORD_CONFIRM_MISMATCH': 'Le mot de passe est différent de sa confirmation.',
  'AUTH_RESET_PASSWORD_SUBMIT': 'Envoyez',
  'AUTH_RESET_PASSWORD_SUBMITTING': 'Envoi en cour...',
  'PLAYERS': 'Players',
  'PAGE_SIZE_ALL': 'Tous',
  'ALL_SUBSCRIPTIONS': 'Tous',
  'ALERT_PLAYERS_LIST_TITLE': 'Alert email players offline ',
  'ALERT_PLAYERS_TEST_MESSAGE_SEND': 'Le test de l\'alert des players offline est en cours d\'envoi par mail.',
  'PLAYER_REPORT_OFFLINE': 'Rapport des players offline ',
  'PLAYERS_DECONNECTED_CREATE': 'Alert email (Player Offline)',
  'PLAYERS_LIST_TITLE': 'Players',
  'PLAYERS_EXPORT_TO_EXCEL': 'Fichier',
  'PLAYERS_EXPORT_TO_EXCEL_BY_EMAIL': 'Email',
  'PLAYER_TYPE': 'Service',
  'PLAYER_SITE': 'Subscription',
  'PLAYER_ID': 'Player ID',
  'PLAYER_STATUS': 'Statut',
  'PLAYER_DEFAULT': 'Defaut',
  'PLAYER_PRODUCT': 'Produit',
  'PLAYER_COUNTRY': 'Pays',
  'PLAYER_LAST_CONNECTION': 'Dernière Connexion',
  'PLAYER_EXTERNAL_ID': 'Shop Id',
  'PLAYER_ONLINE': 'Online',
  'PLAYER_OFFLINE': 'Offline',
  'PLAYER_UPDATE_FAILED': 'Mise à jour échouée',
  'PLAYER_UPDATE_INCOMPLETE': 'Mise à jour partielle',
  'PLAYER_UPDATE_SUCCESS': 'A jour',
  'PLAYER_DELIVERED': 'Livré',
  'PLAYER_NOT_DELIVERED': 'En cours',
  'PLAYERS_LIST_FILTER': 'Filtre',
  'PLAYERS_LIST_FILTER_SITE': 'Site',
  'PLAYERS_LIST_FILTER_PLAYER_ID': 'Player ID',
  'PLAYERS_LIST_FILTER_PLAYER_TYPE': 'Service',
  'PLAYERS_LIST_FILTER_SERVICE_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_SERVICE_AUDIO': 'Seulement les Players Audio',
  'PLAYERS_LIST_FILTER_SERVICE_VIDEO': 'Seulement les Players Vidéo',
  'PLAYERS_LIST_FILTER_PRODUCT': 'Produit',
  'PLAYERS_LIST_FILTER_DEFAULT': 'Defaut?',
  'PLAYERS_LIST_FILTER_DEFAULT_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_DEFAULT_YES': 'Seulement les Players par defaut',
  'PLAYERS_LIST_FILTER_DEFAULT_NO': 'Autres Players',
  'PLAYERS_LIST_FILTER_SEARCH': 'Rechercher',
  'PLAYERS_LIST_FILTER_RESET': 'Réinitialiser',
  'PLAYER_INVENTORY': 'Inventaire',
  'PLAYER_INVENTORY_PAGE_TITLE': 'Portal | Players | Inventaire',
  'COUNTRIES_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des pays.',
  'PLAYERS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des players.',
  'PLAYERS_LOAD_BAD_REQUEST_ERROR': 'Une erreur de validation s\'est produite lors du chargement des players.',
  'PLAYERS_LIST_FILTER_COUNTRY_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_COUNTRY': 'Pays',
  'PLAYERS_LIST_FILTER_UPDATED': 'A jour ?',
  'PLAYERS_LIST_FILTER_UPDATED_YES': 'Players à jour',
  'PLAYERS_LIST_FILTER_UPDATED_INCOMPLETE': 'Players partiellement à jour',
  'PLAYERS_LIST_FILTER_UPDATED_FAILED': 'Players pas à jour. ',
  'PLAYERS_LIST_FILTER_UPDATED_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_ONLINE': 'Online ?',
  'PLAYERS_LIST_FILTER_ONLINE_YES': 'Players online',
  'PLAYERS_LIST_FILTER_ONLINE_NO': 'Players Offline',
  'PLAYERS_LIST_FILTER_ONLINE_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_EXTERNAL_ID': 'Shop Id',
  'PLAYERS_LIST_QUICK_SEARCH': 'Recherche par Player ou Site',
  'PRODUCTS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des produits.',
  'PLAYERS_LIST_FILTER_PRODUCT_DEFAULT': ' ',
  'PLAYER_INFO_TITLE': 'Player Info',
  'PLAYER_GENERAL': 'Général',
  'PLAYER_LOCATION': 'Localisation',
  'PLAYER_SHIPPING': 'Info livraison',
  'PLAYER_CONNECTIVITY': 'Connectivité',
  'PLAYER_MODEL': 'Modèle',
  'PLAYER_DEVICE_ID': 'Device ID',
  'PLAYER_TIMEZONE': 'Fuseau horaire',
  'PLAYER_SITE_STATUS': 'Site Statuts',
  'PLAYER_IP_ADDRESS': 'IP locale',
  'PLAYER_FIRMWARE': 'Firmware',
  'PLAYER_SERIAL_NUMBER': 'Numéro de série',
  'PLAYER_DELIVERY_STATUS': 'Statuts livraison',
  'PLAYER_UPDATED': 'A jour',
  'PLAYER_MAC_ADDRESS': 'Adresse MAC',
  'PLAYER_WIFI_MAC_ADDRESS': 'Adresse MAC Wifi',
  'PLAYER_LAST_UPDATE': 'Dernière mise à jour',
  'PLAYER_LAST_DOWNLOAD': 'Dernier téléchargement',
  'PLAYER_LAST_CONFIG': 'Dernière configuration',
  'PLAYER_LAST_TASK': 'Dernière Tâche',
  'PLAYER_LAST_MONITORING': 'Dernier Monitoring',
  'PLAYER_LAST_PLAY': 'Dernier Play',
  'PLAYER_PUBLIC_IP': 'IP Publique',
  'PLAYER_SITE_STATUS_STOP': 'Stopped',
  'PLAYER_SITE_STATUS_TO_OFF': 'To Off',
  'PLAYER_SITE_STATUS_OFF': 'Off',
  'PLAYER_SITE_STATUS_DEMO': 'Pilot',
  'PLAYER_SITE_STATUS_EXPLOIT': 'Exploit',
  'PLAYER_GENERAL_INFO': 'Info générale',
  'OPENING_HOURS': 'Opening hours',
  'PLAYER_MONITORING_INFO': 'Info monitoring',
  'REFRESH_PLAYER': 'Cliquer ici pour recharger les informations du player.',
  'GEOCODE_OVER_QUERY_LIMIT': 'Google Maps API a été trop souvent solicité.',
  'GEOCODE_GENERIC_ERROR': 'Une erreur s\'est produite lors de la récupération des informations Google Maps sur cette adresse.',
  'GEOCODE_ZERO_RESULTS': 'L\'adresse ne peut être localisée par Google Maps.',
  'PLAYERS_DOWNLOAD_CSV_ERROR': 'Une erreur s\'est produite lors du téléchargement du fichier CSV des Players.',
  'PLAYERS_DOWNLOAD_CSV_START':
    'Le fichier Excel contenant la liste des Players et de leurs informations est en cours de création. Il sera téléchargé automatiquement dans quelques instants.',
  'PLAYER_INFO_ERROR': 'Une erreur s\'est produite lors du chargement des informations du player..',
  'PLAYER_SHIPPING_ERROR': 'Une erreur s\'est produite lors du chargement des informations de livraison du player.',
  'PLAYER_SHIPPING_TYPE': 'Type',
  'PLAYER_SHIPPING_CARRIER': 'Transporteur',
  'PLAYER_SHIPPING_TRACKING': 'Suivi',
  'PLAYER_SHIPPING_PICKUP_DATE': 'Date d\'enlèvement',
  'PLAYER_SHIPPING_DELIVERY_DATE': 'Date de livraison',
  'PLAYER_SHIPPING_DELIVERY_STATUS': 'Statuts de livraison',
  'PLAYER_CONNECTIVITY_ERROR': 'Une erreur s\'est produite lors du chargement des informations statistiques de connexion du player.',
  'PLAYER_LIVE_CONNECTIVITY': 'Qualité de connexion en temps réel',
  'PLAYER_HISTORY_CONNECTIVITY': 'Historique de la qualité de connexion',
  'PLAYER_CONNECTIVITY_LAST_UPDATE': 'Dernière modification :',
  'AUTH_LOGIN_PAGE_TITLE': 'Portal | Authentifiant',
  'AUTH_LOST_PASSWORD_PAGE_TITLE': 'Portal | Mot de passe oublié',
  'AUTH_RESET_PASSWORD_PAGE_TITLE': 'Portal | Réinitialisation du mot de passe',
  'DASHBOARD_PAGE_TITLE': 'Portal | Dashboard',
  'ERROR_ACCESS_DENIED_PAGE_TITLE': 'Portal | Acces non authorisé',
  'ERROR_NOT_FOUND_PAGE_TITLE': 'Portal | Pas trouvé...',
  'PLAYERS_LIST_PAGE_TITLE': 'Portal | Players',
  'PLAYERS_DETAILS_INFO_PAGE_TITLE': 'Portal | Players | Details | Player Info',
  'PLAYERS_DETAILS_PLANNING_TITLE': 'Portal | Players | Details | Planning',
  'PLAYERS_DETAILS_PLAYLIST_TITLE': 'Portal | Players | Details | Playlist',
  'PLAYERS_DETAILS_PLAY_LOGS_TITLE': 'Portal | Players | Details | Play Logs',
  'PLAYERS_DETAILS_EVENT_LOGS_TITLE': 'Portal | Players | Details | Event Logs',
  'PLAYERS_DETAILS_SCHEDULED_MESSAGES_TITLE': 'Portal | Players | Détails | Programmation Messages',
  'USER_PAGE_TITLE': 'Portal | Mon Profile',
  'USERS_LIST_PAGE_TITLE': 'Portal | Utilisateurs',
  'USERS_DETAILS_INFO_PAGE_TITLE': 'Portal | Utilisateurs | Détails | Info Utilisateurs',
  'USERS_DETAILS_SUBSCRIPTIONS_PAGE_TITLE': 'Portal | Utilisateurs | Détails | Info Abonnements',
  'USERS_DETAILS_AUTH0_PAGE_TITLE': 'Portal | Users | Détails | Info Connexions',
  'ANONYMOUS_USERNAME': 'Anonyme',
  'WARNING': 'Warning!',
  'USER_SUBSCRIPTIONS_IMPORT_WARNING':
    'Importer les abonnements d\'un autre utilisateur supprime et remplace les abonnements de l\'utilisateur sélectionné !!!. Il est IMPOSSIBLE d\'annuler cette opération. Cette fonctionnalité doit être utilisée en connaissance de cause.',
  'IMAGE_UPLOAD_INVALID_EXTENSION': 'L\'image importée n\'est pas au bon format ! Seules les images JPEG et PNG sont supportées.',
  'IMAGE_UPLOAD_PROCESSING_ERROR': 'Une erreur s\'est produite lors du traitement de l\'image.',
  'IMAGE_UPLOAD_GENERIC_ERROR': 'Une erreur s\'est produite lors du chargement de l\'image.',
  'PLAYER_AUDIO_UPDATE_SERVER': 'Serveur Relais',
  'PLAYER_AUDIO_PLANNING_TITLE': 'Planning',
  'PLAYER_AUDIO_PLAYLIST_TITLE': 'Playlist',
  'PLAYER_PLAY_LOGS_TITLE': 'Logs de diffusion',
  'PLAYER_EVENT_LOGS_TITLE': 'Logs d\'activité',
  'PLAYER_AUDIO_SCHEDULED_MESSAGES_TITLE': 'Messages programmés',
  'PLAYER_VIDEO_PLAYLIST_TITLE': 'Playlist',
  'AUDIO_PROGRAMS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des programmes audio.',
  'AUDIO_PLANNINGS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des plannings audio..',
  'AUDIO_PLANNINGS_FILTER': 'Filtrer',
  'AUDIO_PLANNINGS_FILTER_PROGRAM': 'Programme',
  'AUDIO_PLANNINGS_FILTER_DAY': 'Jour',
  'AUDIO_PLANNINGS_FILTER_SEARCH': 'Rechercher',
  'AUDIO_PLANNINGS_FILTER_RESET': 'Réinitialiser',
  'AUDIO_PLANNINGS_START': 'Démarrer',
  'AUDIO_PLANNINGS_NAME': 'Nom',
  'AUDIO_PLANNINGS_DURATION': 'Durée',
  'AUDIO_PLANNINGS_TYPE': 'Type',
  'AUDIO_PLANNINGS_PLAY': 'Ecouter',
  'MEDIA_AUDIO_MUSIC': 'Musique',
  'MEDIA_AUDIO_JINGLE': 'Jingle',
  'MEDIA_AUDIO_SEQUENCE': 'Séquence',
  'MEDIA_AUDIO_COMMERCIAL': 'Messages',
  'MEDIA_AUDIO_PAUSE': 'Pause',
  'PLAY_LOGS_FILTER': 'Filtre',
  'PLAY_LOGS_FILTER_SEARCH': 'Rechercher',
  'PLAY_LOGS_FILTER_RESET': 'Réinitialiser',
  'PLAY_LOGS_FILTER_FILENAME': 'Fichier',
  'PLAY_LOGS_FILTER_START_DATE': 'Formulaire (date)',
  'PLAY_LOGS_FILTER_START_TIME': 'Formulaire (heure)',
  'PLAY_LOGS_FILTER_END_DATE': 'Jusqu\'à (date)',
  'PLAY_LOGS_FILTER_END_TIME': 'Jusqu\'à (heure)',
  'PLAYER_PLAY_LOGS_START_TIME': 'Heure de début',
  'PLAYER_PLAY_LOGS_END_TIME': 'Heure de fin',
  'PLAYER_PLAY_LOGS_FILENAME': 'Fichier',
  'PLAYER_PLAY_LOGS_INFO': 'Info',
  'PLAY_LOGS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des logs de diffusion.',
  'EVENT_LOGS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des logs d\'activité..',
  'EVENT_LOGS_FILTER': 'Filter',
  'EVENT_LOGS_FILTER_START_DATE': 'De',
  'EVENT_LOGS_FILTER_END_DATE': 'Jusqu\'à',
  'EVENT_LOGS_FILTER_SEARCH': 'Rechercher',
  'EVENT_LOGS_FILTER_RESET': 'Réinitialiser',
  'EVENT_LOGS_TYPE': 'Type',
  'EVENT_LOGS_NAME': 'Nom',
  'EVENT_LOGS_SOURCE': 'Source',
  'EVENT_LOGS_TIME': 'Heure',
  'EDIT_ALERT_MESSAGE_GERMAN': 'Allemand',
  'AUDIO_PLAYLISTS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement de la playlist audio.',
  'AUDIO_PLAYLISTS_LOAD_EMPTY': 'Pas de données pour cette playlist audio.',
  'AUDIO_SCHEDULED_MESSAGES_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des messages audio programmés.',
  'AUDIO_SCHEDULED_MESSAGES_FILTER': 'Filtre',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY': 'Jour',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_SEARCH': 'Rechercher',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_RESET': 'Réinitialiser',
  'AUDIO_SCHEDULED_MESSAGES_ANNOUNCEMENT': 'Type',
  'AUDIO_SCHEDULED_MESSAGES_CAMPAIGN': 'Campagne',
  'AUDIO_SCHEDULED_MESSAGE_START_DATE': 'De (date)',
  'AUDIO_SCHEDULED_MESSAGE_END_DATE': 'Jusqu\'à (date)',
  'AUDIO_SCHEDULED_MESSAGE_START_TIME': 'De (heure)',
  'AUDIO_SCHEDULED_MESSAGE_END_TIME': 'Jusqu\'à (heure)',
  'AUDIO_SCHEDULED_MESSAGE_MONDAY': 'Lun.',
  'AUDIO_SCHEDULED_MESSAGE_TUESDAY': 'Mar.',
  'AUDIO_SCHEDULED_MESSAGE_WEDNESDAY': 'Mer.',
  'AUDIO_SCHEDULED_MESSAGE_THURSDAY': 'Jeu.',
  'AUDIO_SCHEDULED_MESSAGE_FRIDAY': 'Ven.',
  'AUDIO_SCHEDULED_MESSAGE_SATURDAY': 'Sam.',
  'AUDIO_SCHEDULED_MESSAGE_SUNDAY': 'Dim.',
  'AUDIO_SCHEDULED_MESSAGE_MEDIA_NAME': 'Nom',
  'AUDIO_SCHEDULED_MESSAGE_MEDIA_DURATION': 'Durée',
  'AUDIO_SCHEDULED_MESSAGE_MEDIA_PLAY': 'Joue',
  'AUDIO_PLAYER_NOT_SUPPORTED': 'Votre navigateur ne support pas les éléments audio...',
  'VIDEO_PLAYER_NOT_SUPPORTED': 'Votre navigateur ne support pas les éléments vidéo...',
  'VIDEO_PLAYLISTS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des médias vidéo.',
  'VIDEO_PLAYLISTS_TYPE': 'Type',
  'VIDEO_PLAYLISTS_THUMBNAIL': 'Vignette',
  'VIDEO_PLAYLISTS_MEDIA_NAME': 'Nom',
  'VIDEO_PLAYLISTS_MEDIA_DURATION': 'Durée',
  'VIDEO_PLAYLISTS_SOURCE': 'Source',
  'VIDEO_PLAYLISTS_PROGRAM_MODE': 'Mode du programme',
  'VIDEO_PLAYLISTS_PROGRAM_NAME': 'Nom du Programme',
  'VIDEO_PLAYLISTS_MEDIA_RESOLUTION': 'Résolution',
  'VIDEO_PLAYLISTS_MEDIA_ROTATION': 'Rotation',
  'VIDEO_PLAYLISTS_PLAY': 'Joue',
  'VIDEO_PLAYER': 'Video Player',
  'VIDEO_PLAYLISTS_FILTER': 'Filtre',
  'VIDEO_PLAYLISTS_FILTER_DAY': 'Jour',
  'VIDEO_PLAYLISTS_FILTER_SEARCH': 'Rechercher',
  'VIDEO_PLAYLISTS_FILTER_RESET': 'Réinitialiser',
  'PLAYER_LOGS': 'Logs du Serveur',
  'SOCIAL_LOGIN_INTRO': 'Ou authentifier vous avec',
  'LOGIN_TITLE': 'Se connecter',
  'AUDIO_PLAYLIST_ADN': 'Playlist ADN',
  'AUDIO_PLAYLIST_SHOW_ADN': 'Afficher ADN',
  'AUDIO_PLAYLIST_STATS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des statistiques de la playlist.',
  'AUDIO_PLAYLIST_ADN_TITLE': 'Playlist ADN for {{subscriptionName}}',
  'AUDIO_PLAYLIST_ADN_PROGRAM': 'Programme : {{programName}}',
  'AUDIO_PLAYLIST_ADN_DATE': 'Date : {{date}}',
  'AUDIO_PLAYLIST_ADN_STYLES': 'Styles',
  'AUDIO_PLAYLIST_ADN_THEMES': 'Thêmes',
  'AUDIO_PLAYLIST_ADN_MOOD': 'Mood',
  'AUDIO_PLAYLIST_ADN_GENDERS': 'Genres',
  'AUDIO_PLAYLIST_ADN_LANGUAGES': 'Langues',
  'AUDIO_PLAYLIST_ADN_YEARS': 'Années',
  'AUDIO_PLAYLIST_ADN_ENERGY': 'Energie',
  'AUDIO_PLAYLIST_ADN_TEMPO': 'Tempo',
  'AUDIO_PLAYLIST_ADN_BPM': 'BPM',
  'DEFAULT_TITLE': 'Portal',
  'PLAYER_QUICK_SEARCH_PLACEHOLDER': 'Recherche rapide d\'un player',
  'QUICK_SEARCH_BAD_REQUEST_ERROR': 'A validation error occurred during the search.',
  'QUICK_SEARCH_LOAD_ERROR': 'Une erreur s\'est produite lors de la recherche d\'un player.',
  'QUICK_SEARCH_DIALOG': 'Résultats de la recherche',
  'QUICK_SEARCH_DIALOG_TITLE': 'Résultats de la recherche',
  'PLAYER_CLIENT': 'Client',
  'GOTO_PLAYER': 'Aller vers Players',
  'LINK_EXTERNAL_IDENTITY': 'Associer une indentité externe',
  'ADMIN_ALERTS_LIST_TITLE': 'Portal | Admin | Alertes',
  'ADMIN': 'Admin',
  'ADMIN_ALERTS': 'Alertes',
  'QUICK_SEARCH_NO_RESULT': 'Aucun résultat pour votre recherche.',
  'ALERT_MESSAGES_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement du message d\'alerte.',
  'ALERT_MESSAGES_LIST_TITLE': 'Alertes',
  'ALERT_MESSAGES_START': 'De',
  'ALERT_MESSAGES_END': 'Jusqu\'a\'',
  'ALERT_MESSAGES_MESSAGE': 'Message',
  'ALERT_MESSAGES_AUDIENCE': 'Audience',
  'ALERT_MESSAGES_ACTIONS': 'Actions',
  'ALERT_MESSAGES_AUDIENCE_ANY': 'Aucun',
  'ALERT_MESSAGES_AUDIENCE_STOREVER': 'MCube exclusivement',
  'ALERT_MESSAGES_AUDIENCE_NOTSTOREVER': 'Externe exclusivement',
  'ALERT_MESSAGES_EDIT': 'Editer',
  'ALERT_MESSAGES_DELETE': 'Supprimer',
  'ALERT_MESSAGES_CREATE': 'Créer',
  'ALERT_MESSAGES_EDIT_DIALOG_TITLE': 'Editer le message d\'alerte',
  'ALERT_MESSAGES_CREATE_DIALOG_TITLE': 'Créer un message d\'alerte',
  'EDIT_ALERT_MESSAGE_FRENCH': 'Français',
  'EDIT_ALERT_MESSAGE_DUTCH': 'Néerlandais',
  'EDIT_ALERT_MESSAGE_ENGLISH': 'Anglais',
  'EDIT_ALERT_MESSAGE_SAVE': 'Sauver',
  'EDIT_ALERT_MESSAGE_START_DATE': 'Date de début',
  'EDIT_ALERT_MESSAGE_END_DATE': 'Date de fin',
  'EDIT_ALERT_MESSAGE_PRODUCTS': 'Produit(s) concerné(s)',
  'EDIT_ALERT_MESSAGE_AUDIENCE': 'Afficher audience',
  'EDIT_ALERT_MESSAGE_FRENCH_REQUIRED': 'Un message en français est nécessaire.',
  'EDIT_ALERT_MESSAGE_DUTCH_REQUIRED': 'Un message en néerlandais est nécessaire.',
  'EDIT_ALERT_MESSAGE_ENGLISH_REQUIRED': 'Un message en anglais est nécessaire.',
  'EDIT_ALERT_MESSAGE_FRENCH_MAX_LENGTH': 'Le message en français ne peut pas dépasser 500 caractères.',
  'EDIT_ALERT_MESSAGE_DUTCH_MAX_LENGTH': 'Le message en néerlandais ne peut pas dépasser 500 caractères.',
  'EDIT_ALERT_MESSAGE_ENGLISH_MAX_LENGTH': 'Le message en anglais ne peut pas dépasser 500 caractères.',
  'EDIT_ALERT_MESSAGE_BROADCAST_REQUIRED': 'L\'audience est nécessaire.',
  'EDIT_ALERT_MESSAGE_PRODUCTS_RESET': 'Réinitialiser',
  'CREATE_ALERT_MESSAGE_SUCCESS': 'Le message d\'alarte a été correctement créé.',
  'CREATE_ALERT_MESSAGE_VALIDATION_ERROR': 'Une erreur de validation s\'est produite lors du création du message d\'alerte.',
  'CREATE_ALERT_MESSAGE_ERROR': 'Une erreur s\'est produite lors de la création du message d\'alerte.',
  'UPDATE_ALERT_MESSAGE_SUCCESS': 'Le message d\'alerte a été correctement créé.',
  'UPDATE_ALERT_MESSAGE_VALIDATION_ERROR': 'Une erreur de validation s\'est produite lors de la mise à jour du message d\'alerte.',
  'UPDATE_ALERT_MESSAGE_ERROR': 'Une erreur s\'est produite lors de la mise à jour du message d\'alerte.',
  'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG': 'Confirmation de suppression d\'un message d\'alerte',
  'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG_TITLE': 'Confirmation de suppression',
  'CONFIRM_DELETE_ALERT_MESSAGE_DIALOG_ACCEPT': 'Supprimer',
  'CONFIRM_DELETE_ALERT_MESSAGE_MESSAGE': 'Etes-vous certain de vouloir supprimer ce message d\'alerte ?',
  'DELETE_ALERT_MESSAGE_SUCCESS': 'Le message d\'alerte a été correctement supprimé.',
  'DELETE_ALERT_MESSAGE_ERROR': 'Une erreur s\'est produite lors de la suppression du message d\'alerte.',
  'CURRENT_ALERT_MESSAGES_ERROR': 'Une erreur s\'est produite lors du chargement du message d\'alerte courant.',
  'ADMIN_ROLES_MANAGER_TITLE': 'Portal | Admin | Gestion des Rôles',
  'ADMIN_ROLES_MANAGER': 'Gestions des rôles',
  'ROLES_MANAGER_TITLE': 'Gestions des rôles',
  'ROLES_MANAGER_GROUP_ROLES': 'Groupe de Rôles',
  'ROLES_MANAGER_ADD_GROUP': 'Ajouter',
  'ROLES_MANAGER_REMOVE_GROUP': 'Supprimer',
  'ROLES_MANAGER_SELECT_GROUP': '--- Sélectionner un groupe de rôles ---',
  'GROUP_ROLE_EX_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des détails du groupe de rôle.',
  'GROUP_ROLES_NAME_TEMPLATE': 'Select a existing Template.',
  'GROUP_ROLES_NAME': 'Créer un nouveau groupe de rôles.',
  'ADMIN_GROUP_ROLE_SAVE': 'Sauver',
  'CREATE_GROUP_ROLES_DIALOG': 'Créer un nouveau groupe de rôles',
  'CREATE_GROUP_ROLES_TITLE': 'Créer un nouveau groupe de rôles',
  'CREATE_GROUP_ROLES_BUTTON': 'Créer',
  'GROUP_ROLES_NAME_REQUIRED': 'Le nom du groupe de rôles est nécessaire.',
  'GROUP_ROLES_NAME_MIN_LENGTH': 'Le nom du groupe de rôles doit contenir au moins 3 caractères.',
  'GROUP_ROLES_NAME_MAX_LENGTH': 'Le nom du groupe de rôles ne peut pas dépasser 50 caractères',
  'CONFIRM_DELETE_GROUP_ROLES_DIALOG': 'Confirmation de la suppression d\'un groupe de rôles',
  'CONFIRM_DELETE_GROUP_ROLES_DIALOG_TITLE': 'Confirmer la suppression',
  'CONFIRM_DELETE_EMPTY_GROUP_ROLES_MESSAGE': 'Etes-vous certain de vouloir supprimer le groupe de rôles "{{name}}" ?',
  'CONFIRM_DELETE_GROUP_ROLES_DIALOG_ACCEPT': 'Supprimer',
  'CREATE_GROUP_ROLES_SUCCESS': 'Le groupe de rôles a été correctement créé.',
  'CREATE_GROUP_ROLES_VALIDATION_ERROR': 'Une erreur de validation s\'est produite lors de la création du groupe de rôles.',
  'CREATE_GROUP_ROLES_ERROR': 'Une erreur s\'est produite lors de la création du groupe de rôles.',
  'UPDATE_GROUP_ROLES_SUCCESS': 'Le groupe de rôles a été correctement mis à jour.',
  'UPDATE_GROUP_ROLES_VALIDATION_ERROR': 'Une erreur de validation s\'est produite lors de la mise à jour du groupe de rôles.',
  'UPDATE_GROUP_ROLES_ERROR': 'Une erreur s\'est produite lors de la mise à jour du groupe de rôles.',
  'DELETE_GROUP_ROLES_SUCCESS': 'Le groupe de rôles a été correctement mis à jour.',
  'DELETE_GROUP_ROLES_ERROR': 'Une erreur s\'est produite lors de la supression du groupe de rôles.',
  'EXTERNAL_APPS': 'Plus d\'applications',
  'ROLE_VIEW': 'Peut accéder à l\'application',
  'ROLE_PORTAL_ACTION': 'Peut réaliser des actions',
  'ROLE_PORTAL_EVENTLOG': 'Peut voir les logs d\'activité',
  'ROLE_PORTAL_PLAYLOG': 'Peut voir les logs de diffusion',
  'ROLE_PORTAL_PLANNING': 'Peut voir les plannings',
  'ROLE_PORTAL_TICKET': 'Peut voir les tickets de support',
  'ROLE_RUNAS': 'Peut prendre l\'identité d\'un autre utilisateur',
  'ROLE_PORTAL_USERMGR': 'Peut gérer des utilisateurs',
  'ROLE_PORTAL_STOREVER': 'Peut acceder aux données MCube',
  'ROLE_PORTAL_EXPERT': 'Peut acceder aux données avancées',
  'ROLE_PORTAL_PUBLISH': 'Peut publier sur un player',
  'ROLE_PORTAL_REBOOT': 'Peut rebooter un player',
  'ROLE_PORTAL_SRVLOG': 'Peut voir les logs de serveurs',
  'ROLE_DS_MEDIA': 'Peut acceder à la gestion des médias',
  'ROLE_DS_UPLOAD': 'Peut télécharger un nouveau média',
  'ROLE_DS_EXPERT': 'Peut acceder aux données et actions avancées',
  'ROLE_CREATOR_UPLOAD_IMG': 'Peut téléchager des images',
  'ROLE_CREATOR_UPLOAD_SHAPE': 'Peut téléchargé des formes',
  'ROLE_CREATOR_TEMPLATE_NEW': 'Peut créer un nouveau template',
  'ROLE_CREATOR_TEMPLATE_SHARE': 'Peut partagé des templates',
  'ROLE_DS_SHARE': 'Peut partage média/playlist/programme',
  'ROLE_DS_ROTATE_MEDIA': 'Peut pivoter un média',
  'ROLE_CREATOR_EXPERT': 'Peut acceder aux données et actions avancées',
  'SITE_TITLE': 'Portal',
  'ROLE_DS_PUBLISH': 'Peut publier sur un player',
  'COMMANDS_LOAD_ERROR': 'Une erreur est survenue lors du chargement d\'une action.',
  'ROLE_APS_PROGRAM': 'Peut gérer les programmes',
  'PLAYER_COMMANDS_TITLE': 'Actions envoyées',
  'PLAYER_COMMANDS_PAGE_TITLE': 'Portal | Players | Détails | Actions',
  'COMMANDS_FILTER': 'Filtre',
  'COMMANDS_FILTER_DAY': 'Jour',
  'COMMANDS_FILTER_SEARCH': 'Rechercher',
  'COMMANDS_FILTER_RESET': 'Réinitialiser',
  'COMMANDS_TEXT': 'Action',
  'COMMANDS_NAME': 'Nom',
  'COMMANDS_USER': 'Créateur',
  'COMMANDS_SEND_DATE': 'Envoyé',
  'COMMANDS_RESULT_DATE': 'Répondu',
  'COMMAND_CUSTOM': 'Speciale...',
  'COMMAND_CTEST': 'Test de connexion',
  'COMMAND_DIR': 'Liste du contenu',
  'COMMAND_CURCHAN': 'Programme courant',
  'COMMAND_KCHK': 'Vérifier la clé de décription',
  'COMMAND_CHKDSK': 'Vérifier la carte SD',
  'COMMAND_ISP': 'Récupérer la configuration',
  'COMMAND_STASK': 'Récupérer la liste des tâches',
  'COMMAND_DC': 'Déconnecter',
  'COMMAND_PP_1': 'Jouer Playlist 1',
  'COMMAND_PS_1': 'Jouer Station 1',
  'COMMAND_POWER_ON': 'Allumer',
  'COMMAND_POWER_OFF': 'Eteindre',
  'COMMAND_RANDOM_ON': 'Aléatoire activé',
  'COMMAND_RANDOM_OFF': 'Aléatoire désactivé',
  'COMMAND_STATUS': 'Statuts',
  'COMMAND_TCP_FAST': 'TCP rapide',
  'COMMAND_TCP_NORMAL': 'TCP Normale',
  'COMMAND_TCP_ULTRAFAST': 'TCP ultra rapide',
  'COMMAND_RESTART': 'Redémarrer',
  'COMMAND_SAF': 'Récupérer l\'URL de mise à jour',
  'COMMAND_SDTEST': 'Tester SD-Card',
  'COMMAND_SNUM': 'Récupérer numéro de série',
  'COMMAND_CHANNEL': 'Récupérer liste des programmes',
  'COMMAND_SYSTAT': 'Récupérer le status du système',
  'COMMAND_TIME': 'Récupérer Heure',
  'COMMAND_UCP': 'Mise à jour type Commercial Plan',
  'COMMAND_UCA': 'Mise à jour type Commercials',
  'COMMAND_UP': 'Mise à jour type Music',
  'COMMAND_IDINBG_0': 'Désactiver la mise à jour en arrière plan',
  'COMMAND_IDINBG_1': 'Activier la mise à jour en arrière plan',
  'COMMAND_IDINBG_OFF': 'Désactiver la mise à jour en arrière plan',
  'COMMAND_IDINBG_ON': 'Activier la mise à jour en arrière plan',
  'COMMAND_UD': 'Mise à  jour de la configuration',
  'COMMAND_UO': 'Mise à jour playlist seulement',
  'COMMAND_UF': 'Mise à jour firmware',
  'COMMAND_US': 'Mise à jour schedule',
  'COMMAND_VOLUME_MAX': 'Définir le volume au maximum',
  'SEND_COMMAND_SUCCESS': 'L\'action\' a été ajoutée dans la file pour être transmise au player.',
  'SEND_COMMAND_FAIL': 'Une erreur s\'est produite lors de l\'ajout de l\'action dans la file..',
  'CUSTOM_COMMAND_DIALOG': 'Action spéciale pour le player',
  'CUSTOM_COMMAND_DIALOG_TITLE': 'Action spéciale',
  'SEND_COMMAND_BUTTON': 'Envoyer',
  'CUSTOM_COMMAND_LABEL': 'Entrer la commande de l\'action pour l\'envoyer au player :',
  'CUSTOM_COMMAND_REQUIRED': 'Une commande est nécessaire.',
  'DASHBOARD_ADVANCED_COUNTERS_ERROR': 'Une erreur s\'est produite lors du chargement des compteurs avancés.',
  'DASHBOARD_COUNTERS_ERROR': 'Une erreur s\'est produite lors du chargement des compteurs.',
  'RELOAD': 'Rechargement',
  'LOADING': 'Chargement...',
  'DASHBOARD_COUNTERS_TITLE_LOADING': 'Statistiques des players',
  'DASHBOARD_COUNTERS_TITLE_LOADED': 'Statistiques des players ({{count}} total player(s))',
  'DASHBOARD_COUNTERS_PLAYER_TYPE_CHART': 'Types de player',
  'DASHBOARD_COUNTERS_PLAYER_AUDIO_CHART': 'Player Audio',
  'DASHBOARD_COUNTERS_PLAYER_VIDEO_CHART': 'Player Video',
  'DASHBOARD_COUNTERS_PLAYER_ONLINE_STATUS_CHART': 'Online Statuts',
  'DASHBOARD_COUNTERS_PLAYER_ONLINE_CHART': 'Online',
  'DASHBOARD_COUNTERS_PLAYER_OFFLINE_CHART': 'Offline',
  'DASHBOARD_COUNTERS_PLAYER_UPDATE_STATUS_CHART': 'Statuts des mises à jour',
  'DASHBOARD_COUNTERS_PLAYER_UPDATED_CHART': 'A jour',
  'DASHBOARD_COUNTERS_PLAYER_NOT_UPDATED_CHART': 'Pas à jour',
  'DASHBOARD_COUNTERS_PLAYER_UPDATE_INCOMPLETE_CHART': 'Mise à jour partielle',
  'DASHBOARD_COUNTERS_POINT_FORMAT_PART1': 'Nombre de player(s): ',
  'DASHBOARD_COUNTERS_POINT_FORMAT_PART2': 'Pourcentage de player(s): ',
  'PLAYER_CONNECTIVITY_STATS_ERROR': 'Une erreur s\'est produite lors du chargement des statistique de connexion du player.',
  'DASHBOARD_CONNECTIVITY_STATS_ERROR': 'Une erreur s\'est produite lors du chargement des statistique de connexion des players du client.',
  'DASHBOARD_CONNECTIVITY_TITLE': 'Statistiques de connexion',
  'DASHBOARD_UPDATE_TITLE': 'Statistiques de mise a jour',
  'DASHBOARD_CONNECTIVITY_CHART_TITLE': 'Connectivité de tous les players',
  'DASHBOARD_CONNECTIVITY_CHART_SUBTITLE': 'Cliquer et faites glisser la souris sur le graphique pour agrandir la zone.',
  'DASHBOARD_CONNECTIVITY_CHART_YAXIS': 'Qualité de la connectivité',
  'DASHBOARD_UPDATE_CHART_TITLE': 'Mise à jour de tous les players',
  'DASHBOARD_UPDATE_CHART_SUBTITLE': 'Cliquer et faites glisser la souris sur le graphique pour agrandir la zone.',
  'DASHBOARD_UPDATE_CHART_YAXIS': 'Qualité de la mise à jour',
  'DASHBOARD_SHIPPING_ERROR': 'Une erreur s\'est produite lors du chargement de la liste de livraisons.',
  'DASHBOARD_SHIPPING_INFO_TITLE': 'Info de livraisons',
  'DASHBOARD_SHIPPING_NAME': 'Nom',
  'DASHBOARD_SHIPPING_TYPE': 'Type',
  'DASHBOARD_SHIPPING_CARRIER': 'Transporteur',
  'DASHBOARD_SHIPPING_TRACKING': 'Suivi',
  'DASHBOARD_SHIPPING_PICKUP_DATE': 'Date d\'enlèvement',
  'DASHBOARD_SHIPPING_DELIVERY_DATE': 'Date de livraison',
  'DASHBOARD_SHIPPING_DELIVERY_STATUS': 'Statuts de livraison',
  'DASHBOARD_SHIPPING_NO_DATA': 'Pas de données à afficher ici.',
  'DASHBOARD_ACTIVITY_FEED_TITLE': 'Flux d\'activité',
  'DASHBOARD_ACTIVITY_FEED_ERROR': 'Une erreur s\'est produite lors du chargement du flux d\'activité.',
  'DASHBOARD_ACTIVITY_FEED_CREATE_GROUPROLE': '{{userName}} a créé le groupe de rôles {{name}}',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_GROUPROLE': '{{userName}} a modifié de rôles {{name}}',
  'DASHBOARD_ACTIVITY_FEED_DELETE_GROUPROLE': '{{userName}} a supprimé le groupe de rôles {{name}}',
  'DASHBOARD_ACTIVITY_FEED_CREATE_GROUPROLES': '{{userName}} a créé {{count}} groupes de rôles',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_GROUPROLES': '{{userName}} a modifié {{count}} groupes de rôles',
  'DASHBOARD_ACTIVITY_FEED_DELETE_GROUPROLES': '{{userName}} a supprimé {{count}} groupes de rôles',
  'DASHBOARD_ACTIVITY_FEED_CREATE_USER': '{{userName}} a créé l\'utilisateur <a href="/users/{{uuid}}">{{name}}</a>',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_USER': '{{userName}} a modifié l\'utilisateur <a href="/users/{{uuid}}">{{name}}</a>',
  'DASHBOARD_ACTIVITY_FEED_DELETE_USER': '{{userName}} a supprimé l\'utilisateur {{name}}',
  'DASHBOARD_ACTIVITY_FEED_CREATE_USERS': '{{userName}} a créé {{count}} utilisateurs',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_USERS': '{{userName}} a modifié {{count}} utilisateurs',
  'DASHBOARD_ACTIVITY_FEED_DELETE_USERS': '{{userName}} a supprimé {{count}} utilisateurs',
  'DASHBOARD_ACTIVITY_FEED_NO_DATA': 'Pas d\'activité à afficher ici.',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_CLIENT': '{{userName}} à mis a jour le client',
  'DASHBOARD_ACTIVITY_FEED_UPDATE_SCHEDULE_AUDIO_COMMERCIAL': '{{userName}} à programmé un audio',
  'DASHBOARD_ACTIVITY_FEED_DELETE_MEDIA': '{{userName}}  a éffacé le media',
  'DASHBOARD_ACTIVITY_FEED_TEST_CLIENT': '{{userName}} teste client',
  'DASHBOARD_LAST_SERVER_CALL_ERROR': 'Une erreur s\'est produite lors du chargement du dernier appel du serveur relais.',
  'DASHBOARD_LAST_SERVER_CALL_TITLE': 'Status du serveur relais',
  'DASHBOARD_LAST_SERVER_CALL_ONLINE': 'Le serveur relais est online',
  'DASHBOARD_LAST_SERVER_CALL_OFFLINE': 'Le serveur relais est offline',
  'DASHBOARD_LAST_SERVER_CALL_NO_DATA': 'Pas de statut de serveur relais à afficher ici.',
  'DASHBOARD_LOGMATIC_ANALYZES_TITLE': 'Rapport Logmatic',
  'DASHBOARD_LOGMATIC_ANALYZES_ERROR': 'Une erreur s\'est produite lors du chargement du rapport Logmatic.',
  'DASHBOARD_LOGMATIC_ANALYZES_NO_DATA': 'Pas de rapport Logmatic à afficher ici.',
  'DASHBOARD_LOGMATIC_ANALYZES_ERROR_CODE': 'Code d\'erreur',
  'DASHBOARD_LOGMATIC_ANALYZES_ERROR_NUMBER': '# Erreurs',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS': 'Statuts de livraison',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS_DEFAULT': ' ',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS_DELIVERED': 'Livré',
  'PLAYERS_LIST_FILTER_DELIVERY_STATUS_IN_TRANSIT': 'En cours',
  'AUTH_LOGIN_TITLE': 'Se connecter',
  'ADMIN_CLIENTS_LIST_TITLE': 'Portal | Admin | Clients',
  'ADMIN_CLIENTS': 'Clients',
  'ADMIN_CLIENTS_LIST_FILTER': 'Filtrer',
  'ADMIN_CLIENTS_LIST_FILTER_SEARCH': 'Rechercher',
  'ADMIN_CLIENTS_LIST_FILTER_RESET': 'Réinitialiser',
  'ADMIN_CLIENTS_LIST_FILTER_NAME': 'Nom',
  'ADMIN_CLIENTS_LIST_FILTER_OFFICE': 'Bureau',
  'ADMIN_CLIENTS_LIST_FILTER_SALES': 'Sales',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES': 'Services',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES_DEFAULT': ' ',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES_AUDIO': 'Audio',
  'ADMIN_CLIENTS_LIST_FILTER_SERVICES_VIDEO': 'Vidéo',
  'ADMIN_CLIENTS_LIST_CREATE': 'Créer',
  'CLIENTS_LIST_LOAD_BAD_REQUEST_ERROR': 'Il y a une erreur dans le filtre de recherche.',
  'CLIENTS_LIST_LOAD_ERROR': 'Une erreur s\'est produite lors de la récupération de la liste des clients.',
  'ADMIN_CLIENTS_NAME': 'Nom',
  'ADMIN_CLIENTS_CUSTOMER_ID': 'Customer ID',
  'ADMIN_CLIENTS_C_NAME': 'CName',
  'ADMIN_CLIENTS_OFFICE': 'Bureau',
  'ADMIN_CLIENTS_SALES': 'Reponsable commercial',
  'ADMIN_CLIENTS_SERVICES': 'Service(s)',
  'ADMIN_CLIENTS_UPDATED': 'Modifié',
  'ADMIN_CLIENTS_CREATED': 'Créé',
  'SALES_LOAD_ERROR': 'Une erreur s\'est produite lors de la récupération de la liste des responsables commerciaux.',
  'ADMIN_EDIT_CLIENT': 'Portal | Admin | Editer Client',
  'ADMIN_CREATE_CLIENT': 'Portal | Admin | Créer Client',
  'CLIENT_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des informations détaillées du client.',
  'EDIT_CLIENT_TITLE': 'Editer client {{name}}',
  'CREATE_CLIENT_TITLE': 'Créer nouveau client',
  'SAVE_CLIENT_BUTTON': 'Sauver',
  'CREATE_CLIENT_BUTTON': 'Créer',
  'CLIENT_NAME': 'Nom',
  'CLIENT_OFFICE': 'Bureau',
  'CLIENT_SALES': 'Reponsable commercial',
  'CLIENT_SERVICES': 'Services',
  'CLIENT_SERVICE_AUDIO': 'Audio',
  'CLIENT_SERVICE_VIDEO': 'Vidéo',
  'CLIENT_APPLICATIONS': 'Applications',
  'CURRENT_CLIENT_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des informations détaillées du client courant.',
  'CLIENT_SALES_ME_BUTTON': 'Moi !',
  'ADMIN_CLIENT_NOT_SALESMAN': 'Vous n\'avez pas de contact commerciale référencé. Sélectionner son nom dans la liste.',
  'CLIENT_NAME_REQUIRED': 'Un nom du client est nécessaire.',
  'CLIENT_NAME_MAX_LENGTH': 'Le nom du client ne peut pas dépasser 50 caractères.',
  'CLIENT_OFFICE_REQUIRED': 'Un bureau est nécessaire.',
  'CLIENT_SALES_REQUIRED': 'Un responsable commercial est nécessaire.',
  'CLIENT_APPS_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement des applications du client.',
  'CREATE_CLIENT_VALIDATION_ERROR': 'Une erreur de validation s\'est produite lors de la création du client.',
  'CREATE_CLIENT_ERROR': 'Une erreur s\'est produite lors de la création du client.',
  'CREATE_CLIENT_SUCCESS': 'Le nouveau client a été correctement créé.',
  'UPDATE_CLIENT_VALIDATION_ERROR': 'Une erreur de validation s\'est produite lors de la modification du client.',
  'UPDATE_CLIENT_ERROR': 'Une erreur s\'est produite lors de la modification du client.',
  'UPDATE_CLIENT_SUCCESS': 'Le client a été correctement modifié.',
  'AUTH_LOGIN_ERROR_TITLE': 'Une erreur s\'est produite',
  'AUTH_LOGIN_ERROR_PARA': 'L\'erreur suivante s\'est produite lors de votre connexion:',
  'AUTH_LOGIN_GO_BACK_BUTTON': 'Retour à la page de login',
  'USER_PROFILE_LOAD_ERROR': 'Une erreur s\'est produite lors du chargement de votre profil depuis le fournisseur d\'identité.',
  'USER_UNBLOCKED': ' ',
  'USER_BLOCKED': 'Bloqué',
  'AUTH_NEW_PASSWORD_PAGE_TITLE': 'Portal | Choisissez votre mot de passe',
  'AUTH_NEW_PASSWORD_TITLE': 'Choisissez votre mot de passe',
  'AUTH_NEW_PASSWORD_PARA': 'Entrer votre mot et confirmer le une seconde fois.',
  'AUTH_NEW_PASSWORD_ERROR': 'Une erreur s\'est produite lors de l\'envoi de votre mot de passe.',
  'AUTH_NEW_PASSWORD_SUCCESS': 'Votre mot de passe a correctement été sauvé.',
  'AUTH_NEW_PASSWORD_NEW': 'Mot de passe.',
  'AUTH_NEW_PASSWORD_NEW_REQUIRED': 'Le mot de passe est nécessaire.',
  'AUTH_NEW_PASSWORD_NEW_MINLENGTH': 'Le mot de passe doit contenir au moins 4 charactères.',
  'AUTH_NEW_PASSWORD_CONFIRM': 'Confirmation du mot de passe.',
  'AUTH_NEW_PASSWORD_CONFIRM_MISMATCH': 'Le mot de passe est différent de sa confirmation.',
  'AUTH_NEW_PASSWORD_SUBMIT': 'Envoyez',
  'AUTH_NEW_PASSWORD_SUBMITTING': 'Envoi en cour...',
  'PAGER_FIRST': 'Première',
  'PAGER_PREVIOUS': 'Précédent',
  'PAGER_NEXT': 'Suivant',
  'PAGER_LAST': 'Dernière',
  'USER_SUBSCRIPTIONS_FILTER': 'Filtrer les players',
  'EDIT_ALERT_MESSAGE_START_DATE_REQUIRED': 'La date de début est obligatoire.',
  'EDIT_ALERT_MESSAGE_START_DATE_INVALID': 'La date de début est invalide (Le format est JJ/MM/AAAA HH:mm).',
  'EDIT_ALERT_MESSAGE_END_DATE_REQUIRED': 'La date de fin est obligatoire.',
  'EDIT_ALERT_MESSAGE_END_DATE_INVALID': 'La date de fin est invalide (Le format est JJ/MM/AAAA HH:mm).',
  'EDIT_ALERT_MESSAGE_END_DATE_NOT_AFTER_START_DATE': 'La date de fin doit être après la date de début.',
  'EDIT_ALERT_MESSAGE_START_DATE_TOO_EARLY': 'La date de début ne peut pas être dans le passé.',
  'COMMAND_LIST_FILTER_DAY_REQUIRED': 'Le jour est obligatoire.',
  'COMMAND_LIST_FILTER_DAY_INVALID': 'Le jour est invalide (Le format est JJ/MM/AAAA).',
  'DATE_TIME_PLACEHOLDER': 'JJ/MM/AAAA HH:mm',
  'DATE_PLACEHOLDER': 'JJ/MM/AAAA',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY_REQUIRED': 'Le jour est obligatoire.',
  'AUDIO_SCHEDULED_MESSAGES_FILTER_DAY_INVALID': 'Le jour est invalide (Le format est JJ/MM/AAAA).',
  'VIDEO_PLAYLIST_FILTER_DAY_REQUIRED': 'Le jour est obligatoire.',
  'VIDEO_PLAYLIST_FILTER_DAY_INVALID': 'Le jour est invalide (Le format est JJ/MM/AAAA).',
  'VIDEO_PLAYLIST_FILTER_DAY_NOT_IN_RANGE': 'Le jour doit être compris entre {{from}} and {{to}}.',
  'AUDIO_PLANNING_FILTER_DAY_REQUIRED': 'Le jour est obligatoire.',
  'AUDIO_PLANNING_FILTER_DAY_INVALID': 'Le jour est invalide (Le format est JJ/MM/AAAA).',
  'AUDIO_PLANNING_FILTER_DAY_NOT_IN_RANGE': 'Le jour doit être compris entre {{from}} and {{to}}.',
  'EVENT_LOGS_FILTER_START_DATE_REQUIRED': 'La date "de" est obligatoire.',
  'EVENT_LOGS_FILTER_START_DATE_INVALID': 'La date "de" est invalide (Le format est JJ/MM/AAAA HH:mm).',
  'EVENT_LOGS_FILTER_END_DATE_REQUIRED': 'La date "jusqu\'à" est obligatoire.',
  'EVENT_LOGS_FILTER_END_DATE_INVALID': 'La date "jusqu\'à" est invalide (Le format est JJ/MM/AAAA HH:mm).',
  'EVENT_LOGS_FILTER_END_DATE_NOT_AFTER_START_DATE': 'La date "de" doit être avant la date "jusqu\'à".',
  'PLAY_LOGS_FILTER_START_DATE_REQUIRED': 'La date "de" est obligatoire.',
  'PLAY_LOGS_FILTER_START_DATE_INVALID': 'La date "de" est invalide (Le format est JJ/MM/AAAA HH:mm).',
  'PLAY_LOGS_FILTER_END_DATE_REQUIRED': 'La date "jusqu\'à" est obligatoire.',
  'PLAY_LOGS_FILTER_END_DATE_INVALID': 'La date "jusqu\'à" est invalide (Le format est JJ/MM/AAAA HH:mm).',
  'PLAY_LOGS_FILTER_END_DATE_NOT_AFTER_START_DATE': 'La date "de" doit être avant la date "jusqu\'à".',
  'DASHBOARD_ACTIVITY_FEED_CREATE_CLIENT': '{{userName}} a créé le client {{name}}',
  'PLAY_LOGS_FILTER_EXCEEDED': 'Logs are maximum {{logs}} days time life',
  'DATATABLE_DEFAULT_EMPTY_TEXT': 'Aucune données à afficher.',
  'CONFIRM_DELETE_NON_EMPTY_GROUP_ROLES_MESSAGE_ONE':
    'Un utilisateur est encore assigné au groupe de rôles "{{name}}". Dans quel autre groupe rôles voulez-vous le déplacer?',
  'CONFIRM_DELETE_NON_EMPTY_GROUP_ROLES_MESSAGE_MANY':
    'Des utilisateurs sont encore assignés au groupe de rôles "{{name}}". Dans quel autre groupe de rôles voulez-vous les déplacer?',
  'ADMIN_CLIENTS_APPS': 'Application(s)',
  'ADMIN_CLIENT_APP_1': 'Portal',
  'ADMIN_CLIENT_APP_2': 'DSManager',
  'ADMIN_CLIENT_APP_3': 'Creator',
  'ADMIN_CLIENT_APP_4': 'AudioManager',
  'DATETIME_PICKER_TODAY': 'Aujourd\'hui',
  'DATETIME_PICKER_CLEAR': 'Effacer',
  'DATETIME_PICKER_CLOSE': 'Fermer',
  'DATETIME_PICKER_SELECT_MONTH': 'Sélectionner le mois',
  'DATETIME_PICKER_PREV_MONTH': 'Mois précédent',
  'DATETIME_PICKER_NEXT_MONTH': 'Mois suivant',
  'DATETIME_PICKER_SELECT_YEAR': 'Sélectionner l\'année',
  'DATETIME_PICKER_PREV_YEAR': 'Année précédente',
  'DATETIME_PICKER_NEXT_YEAR': 'Année suivante',
  'DATETIME_PICKER_SELECT_DECADE': 'Sélectionner la décennie',
  'DATETIME_PICKER_PREV_DECADE': 'Décennie précédente',
  'DATETIME_PICKER_NEXT_DECADE': 'Décénnie suivante',
  'DATETIME_PICKER_PREV_CENTURY': 'Siècle précédent',
  'DATETIME_PICKER_NEXT_CENTURY': 'Siècle suivant',
  'DATETIME_PICKER_INCREMENT_HOUR': 'Incrémenter les heures',
  'DATETIME_PICKER_PICK_HOUR': 'Choisir l\'heure',
  'DATETIME_PICKER_DECREMENT_HOUR': 'Décrémenter les heures',
  'DATETIME_PICKER_INCREMENT_MINUTE': 'Incrémenter les minutes',
  'DATETIME_PICKER_PICK_MINUTE': 'Choisir la minute',
  'DATETIME_PICKER_DECREMENT_MINUTE': 'Décrémenter les minutes',
  'DATETIME_PICKER_INCREMENT_SECOND': 'Incrémenter les secondes',
  'DATETIME_PICKER_PICK_SECOND': 'Choisir la seconde',
  'DATETIME_PICKER_DECREMENT_SECOND': 'Décrémenter les secondes',
  'CULTURE_COMMON': 'Cultures communes',
  'CULTURE_OTHERS': 'Autres cultures',
  'PLAYER_PLAY_LOGS_NAME': 'Nom',
  'PLAYER_CACHE': 'Cache du Serveur',
  'ROLE_APS_MEDIA': 'Peut gérer les médias',
  'ROLE_APS_PUBLISH': 'Peut publier sur un player',
  'ROLE_APS_EXPERT': 'Peut acceder aux données et actions avancées',
  'CREATE_USER_NO_GROUPS': 'Aucun groupe de roles n\'est défini pour ce client.',
  'EDIT_CLIENT_INFO': 'Info Client',
  'INVENTORY_LAST_MODIFICATION': 'Dernière modification',
  'WARNING_MESSAGE_PLANNING_UPDATE_FAIL':
    'Le planning est proposé seulement à titre indicatif. La chronologie  peut être altérée par de nombreux facteurs indépendants du Player. Par exemple, l\'ajout de messages de publicitaire provoquer un décalage du planning musical qui peut varier en fonctions de la quantité de messages à diffuser sur 24 heures.',
  'WARNING_MESSAGE_PLAYLIST_UPDATE_FAIL':
    'La playlist est proposée seulement à titre indicatif. Elle peut être altérée par de nombreux facteurs indépendants du Player. Par exemple si la mise à jour journalière a échouée ou est incomplète, les fichiers audio manquants ne seront pas diffusés.',
  'WARNING_TITLE_UPDATE_FAIL': 'Pour votre information.',
  'ROLE_APS_CAMPAIGN': 'Peut gérer les campagnes',
  'ROLE_APS_UPLOAD': 'Peut ajouter des nouveaux medias',
  'ROLE_APS_SHARE': 'Peut partager des médias',
  'ROLE_APS_MUSTVALIDMEDIA': 'Doit valider les medias',
  'ROLE_VIEW_CORPORATE': 'Peut tout voir',
  'ROLE_APS_CAMPAIGN_SUBSCRIPTION': 'Peut gérer les campagnes locales',
  'ROLE_EDIT_CORPORATE': 'Peut tout éditer',
  'ROLE_PORTAL_VIEWUPDATESTATUS': 'Peut voir les status d\'update des players',
  'ROLE_DS_PLAYLIST': 'Peut gérer les playlists',
  'ROLE_DS_PROGRAM': 'Peut gérer les programs',
  'ROLE_PORTAL_OPENING': 'Peut gérer les heures d\'ouverture',
  'ROLE_PORTAL_INVENTORY': 'Peut voir les inventaires',

  'GO_BACK': 'Retour',

  'PRIVACY_POLICY': 'Politique de Confidentialité',
  'TERMS_OF_USE': 'Conditions d’usage',

  'CLUF_TERMS_OF_USE': 'CONDITIONS D’UTILISATION ',
  'CLUF_TERMS_OF_USE_TEXT':
    'Les présentes conditions générales définissent les conditions d’accès et d’utilisation du site internet et des sites connexes de MCube (ci-après le Site) ainsi que les conditions d’utilisation des services inter-actifs (les Services) proposés et maintenus pour vous (ci-après Utilisateur) par MCube sur son Site.  Les Services sont accessibles aux seuls clients de MCube (ci-après les Clients) pour la durée du contrat de sonorisation (audio et/ou visuel) (ci-après le Contrat) qu’ils ont par ailleurs conclu avec MCube.  Il s’agit notamment des services d’hébergement, d’envoi de newsletters, de mise à disposition de contenus créés à la demande du client et d’outils pour la création de contenus multimédias et la programmation de messages et campagnes audio-visuelles (ci-après Contenus). Les Services comprennent également la mise à disposition d’outils permettant la gestion des programmes (ci-après Programmes) du Client et le service après-vente.  L’utilisation des Services implique que vous acceptez les présentes Conditions d’Utilisation. Il se peut que des conditions additionnelles ou particulières à certains Services s’appliquent. Ces conditions additionnelles seront alors mises à votre disposition avec les services concernés.',

  'CLUF_USE_OF_OUR_SERVICES': 'Utilisation de nos Services ',
  'CLUF_USE_OF_OUR_SERVICES_TEXT':
    'Vous vous engagez à respecter les règles applicables aux Services mis à votre disposition et à ne pas les utiliser de façon impropre. Vous ne pouvez pas, notamment, produire des interférences avec nos Services ou tenter d’accéder à notre Site ou nos Services en utilisant une méthode autre que l’interface et les instructions que nous mettons à votre disposition. Vous ne devez utiliser nos Services que dans le respect de la réglementation en vigueur. Nous pouvons suspendre ou cesser l’accès à notre Site et la fourniture de nos Services si vous ne respectez pas les conditions ou la réglementation applicables, ou si nous avons des suspicions étayées d’utilisation impropre. Vous n’êtes pas autorisé à copier, modifier, distribuer, vendre ou louer une partie ou la totalité de nos Site, Services ou des logiciels qui en font partie. De même, vous n’êtes pas autorisé à décompiler ou tenter d’extraire le code source de ces logiciels, hormis dans les cas où le droit de décompilation est autorisé par la loi et dans les limites édictées par cette loi, ou que vous avez obtenu notre autorisation préalable écrite. L’utilisation de nos Site et Services ne vous confère aucun droit d’utilisation ou de propriété intellectuelle sur les Contenus auxquels vous accédez ou créez à partir de nos Contenus, sauf disposition contraire du Contrat. Les Contenus comprennent, notamment toutes informations, marques, créations protégées ou non par le droit de la propriété intellectuelle telles que photographies, musiques, textes, vidéos, logiciels, tableaux, outils de gestion…. Nos Site et Services peuvent afficher des Contenus ne nous appartenant pas, qui peuvent notamment avoir été apportés par nos Clients. Ces Contenus relèvent de l’entière responsabilité du Client ou de l’entité qui les a rendus disponibles. Nous pouvons être amenés à vérifier les Contenus pour s’assurer de leur conformité à la réglementation applicable ou à nos Conditions d’Utilisation et les supprimer en cas de non-conformité. En particulier, nous pouvons désactiver les comptes des Utilisateurs ayant porté atteinte aux droits d’auteurs et droits voisins. Toutefois, le fait que nous nous réservions ce droit de vérification et de suppression ne signifie pas que nous vérifions nécessairement les Contenus.',

  'CLUF_PROTECTION_OF_PRIVACY': 'Protection de la vie privée',
  'CLUF_PROTECTION_OF_PRIVACY_TEXT':
    'La Politique de Confidentialité de MCube explique comment nous traitons vos données à caractère personnel et protégeons votre vie privée lors de votre utilisation de nos Site et Services. Vous acceptez expressément ces règles de confidentialité avant d’utiliser nos Services ou d’adhérer à notre newsletter.',

  'CLUF_CONTENT': 'Contenus',
  'CLUF_CONTENT_TEXT':
    'Certains de nos Services vous permettent d\'importer, de soumettre, de stocker, d\'envoyer ou de recevoir des contenus. Vous conservez tous vos droits de propriété intellectuelle sur ces contenus. Vous garantissez par ailleurs à MCube la légalité du contenu que vous publiez sur le Site et l’exactitude des informations, en particulier les informations commerciales vous concernant. Lorsque vous importez, soumettez, stockez, envoyez à ou recevez des contenus via nos Services, vous accordez à MCube une licence, pour la durée de votre Contrat et dans le monde entier, d\'utilisation, d\'hébergement, de stockage, de reproduction, de modification, de création d\'œuvres dérivées (des traductions, des adaptations ou d\'autres modifications destinées à améliorer le fonctionnement de vos contenus par le biais de nos Services), de communication, de publication, de représentation publique, d\'affichage public ou de distribution publique desdits contenus. L’utilisation des Contenus crées pour vous et mis à disposition par MCube est soumise aux termes, conditions et limitations du Contrat que vous avez conclu. MCube ne pourra être tenu responsable de toute utilisation en dehors des conditions du Contrat.',

  'CLUF_AMENDMENT_AND_TERMINATION': 'Modification et résiliation de nos Services',
  'CLUF_AMENDMENT_AND_TERMINATION_TEXT':
    'MCube modifie et améliore régulièrement ses Services. MCube est susceptible d’ajouter ou de supprimer des fonctionnalités, mais également de suspendre, cesser de vous fournir tout ou partie des Services, ou d’ajouter ou de créer de nouvelles limites à l’utilisation des Services et ce, à tout moment.',

  'CLUF_WARRANTIES_AND_DISCLAIMERS': 'Garanties et clauses de non-responsabilité',
  'CLUF_WARRANTIES_AND_DISCLAIMERS_TEXT':
    'Le Site et les Services fournis par MCube sont soumis à une obligation de moyens. Ils font l’objet d’une limitation de garantie dans les limites permises par la loi. MCube ne souscrit aux termes des présentes Conditions d’Utilisation aucun engagement concernant le contenu du Site et des Services, leurs fonctionnalités spécifiques, leur fiabilité, leur disponibilité ou leur adéquation à vos besoins. MCube ne peut pas non plus être tenu responsable de l’éventuelle incompatibilité des outils et logiciels que vous utilisez pour accéder à nos Services. Dans les limites permises par la loi, MCube, décline toute responsabilité pour les pertes de bénéfices, de revenus ou de données, ou les dommages et intérêts indirects, spéciaux, consécutifs, exemplaires ou punitifs, que vous pourriez subir. En tout état de cause, la responsabilité de MCube, pour toute réclamation dans le cadre des présentes Conditions d’Utilisation, sera limitée aux pertes ou dommages raisonnablement prévisibles et aux montants payés pour utiliser les Services.',

  'CLUF_ACCESS_RIGHTS': 'Droits d’accès à nos Services',
  'CLUF_ACCESS_RIGHTS_TEXT':
    'Lorsque vous utilisez nos Services pour le compte d’une entreprise, vous agissez au nom et pour le compte de cette dernière et avez recueilli préalablement les autorisations requises selon ses règles de fonctionnement internes pour agir en tant qu’administrateur et/ou utilisateur de l’interface et des Services inter-actifs mis à votre disposition.',

  'CLUF_CHANGES_TO_THE_TERMS': 'Modification des Conditions d’Utilisation',
  'CLUF_CHANGES_TO_THE_TERMS_TEXT':
    'Les modifications des Conditions d’Utilisation ne s’appliquent pas de façon rétroactive et entrent en vigueur au moins huit (8) jours après leur publication. Toutefois, les modifications spécifiques à une nouvelle fonctionnalité d’un Service ou les modifications apportées pour des raisons juridiques s’appliquent immédiatement. Si vous n’acceptez pas les modifications apportées aux Conditions d’Utilisation vous devez cesser toute utilisation de nos Services.',

  'CLUF_APPLICABLE_LAW': 'Droit Applicable',
  'CLUF_APPLICABLE_LAW_TEXT':
    'En cas de conflit entre ces Conditions d’Utilisation et/ou des conditions additionnelles et/ou le Contrat, c’est d’abord le Contrat puis les conditions additionnelles qui prévalent. Si vous ne respectez pas ces Conditions d’Utilisation et que nous ne prenons pas immédiatement de mesure à ce sujet, cela ne signifie pas que nous renonçons à nos droits. S’il s’avère qu’une clause/condition particulière n’est pas applicable, cela sera sans incidence sur les autres dispositions de ces Conditions d’Utilisation. Les présentes Conditions d’Utilisation sont soumises au droit belge et aux juridictions francophones de Bruxelles, dans les limites permises par la loi s’agissant notamment d’Utilisateurs qui ne seraient pas des entreprises.',

  'SCOPE_OF_APPLICATION': 'Champs d’application ',
  'SCOPE_OF_APPLICATION_TEXT':
    'A l’occasion de votre visite, de l’utilisation de notre Site et nos Services, MCube collecte, traite et le cas échéant transfert vos données personnelles dans le respect de la réglementation applicable (Règlement Général sur la Protection des Données à caractère Personnel et législation nationale belge). Les nouvelles technologies sont essentielles dans notre activité et les services que nous vous proposons, tels que la mise à disposition de contenus, d’outils pour la création de contenus multimédias et la programmation de messages et campagnes audio-visuelles. La présente Politique de Confidentialité décrit les mesures prises pour la protection de votre vie privée lors de l’utilisation du Site et/ou des Services et les droits dont vous disposez à cet égard en tant qu’Utilisateur et/ou Client. Elle définit la manière dont votre consentement personnel est recueilli ainsi que les finalités du traitement. En accédant et en poursuivant votre navigation sur le Site et/ou en utilisant les Services, vous déclarez avoir lu attentivement, pris connaissance et avoir accepté, sans restriction ni réserve, la présente Politique de Confidentialité. Des adaptations futures ne sont pas à exclure ; toute adaptation apportée sera publiée sur cette page. Nous vous recommandons dès lors de lire régulièrement ladite Politique de Confidentialité.',

  'CONTROLLER': 'Le responsable du traitement',
  'CONTROLLER_TEXT':
    'Le responsable du traitement est la SPRL Storever Belgium, située Boulevard International 55 à 1070 Anderlecht, Belgique, immatriculée au Registre des Personnes Morales sous le numéro 0666834913 ; personne de contact : support@mcubedigital.com',

  'DATA_WE_COLLECT': 'Données que nous collectons',

  'STANDARD_DATA': 'Données Standard',
  'STANDARD_DATA_TEXT':
    'Lors de chaque visite du Site ou de l’utilisation des Services, notamment lorsque vous créez un compte, les données à caractère personnel suivantes sont collectées :',

  'YOUR_IP_ADDRESS': 'Votre adresse IP,',
  'THE_DNS_ADDRESS': 'L’Adresse DNS,',
  'THE_DATE_AND_DURATION': 'La date et la durée de votre visite sur le Site,',
  'THE_PAGES_YOU_VISIT': 'Les pages que vous visitez sur le Site,',
  'YOUR_BROWSER': 'Votre navigateur,',
  'URL_REFERRER': 'Referrer URL.',

  'PERSONAL_CONTACT_DATA': 'Données de contact personnel',
  'PERSONAL_CONTACT_DATA_TEXT':
    'Pour utiliser les Services offerts sur notre Site ainsi que pour la mise à disposition de Contenus et Programmes, vous créez ou finalisez un compte utilisateur (ci-après le « Compte Utilisateur »), aux termes duquel vous fournissez les données personnelles suivantes :',

  'YOUR_FIRST_AND_LAST_NAMES': 'Vos noms et prénoms, votre genre,',
  'YOUR_OCCUPATION': 'Votre fonction, au sein de la société Cliente le cas échéant,  ',
  'YOUR_EMAIL_ADDRESS': 'Votre adresse e-mail,',
  'YOUR_WORK_PHONE_NUMBER': 'Votre numéro de téléphone professionnel (mobile et ou fixe), de fax, skype, à titre optionnel,',
  'YOUR_TIME_ZONE': 'Votre fuseau horaire, à titre optionnel également.',

  'THESE_DATA_ARE_ALSO_COLLECTED':
    'Ces données sont également collectées et traitées, afin de vous livrer les Players et de vous fournir une assistance particulière. En sus, les données suivantes seront conservées pour l’exécution du contrat :',

  'PHONE_CALLS': 'Appels téléphoniques,',
  'MESSAGES_SENT_THROUGH': 'Messages envoyés sur notre service de messagerie en ligne',

  'NO_SENSITIVE_DATA_SHALL_BE_COLLECTED': 'Aucune donnée sensible n’est collectée.',

  'NEWSLETTER': 'Newsletter',
  'NEWSLETTER_TEXT':
    'Nous pouvons vous envoyer des emails de prospections commerciales (« Newsletters ») si vous nous avez donné votre consentement pour cela. Nos Newsletters comprennent des informations sur nos services existants ainsi que sur nos nouveaux services. Vous pouvez vous désinscrire pour ne plus recevoir de Newsletters, en cliquant sur le lien de désinscription que nous ajoutons à toutes nos Newsletters.Veuillez noter que si vous nous demandez de ne plus vous adresser de Newsletters, nous conserverons une trace de vos informations personnelles et de votre demande pour nous assurer que vous soyez exclus de la liste d’envoi des Newsletters.',

  'CONNECTION_TO_THE_SERVICE': 'Connexion à des service et contenu en provenance de tiers',
  'CONNECTION_TO_THE_SERVICE_TEXT':
    'Parfois, le contenu provenant de tiers - par exemple, des vidéos de YouTube, des cartes de Google Maps, des bases de données RSS ou des graphiques provenant d\'autres sites - peut être intégré à l\'offre en ligne. Cela signifie également que le propriétaire du contenu (en référence au propriétaire tiers) recueille l\'adresse IP de l\'utilisateur. Cela est logique parce que sans une adresse IP, le contenu ne peut pas être envoyé aux utilisateurs respectifs. L\'adresse IP est également requise pour la représentation du contenu. Nous veillons à utiliser uniquement le contenu que les propriétaires envoient directement via l\'adresse IP. De plus, nous n\'avons absolument aucun contrôle sur la façon dont le tiers va stocker l\'adresse IP, par ex. pour des analyses statistiques. Si nous prenons conscience de telles pratiques, nous informerons le client',

  'COOKIES': 'Cookies',
  'COOKIES_TEXT':
    'Les cookies sont des fichiers texte qui nous permettent de stocker des informations sur votre ordinateur client. Les informations sur les cookies peuvent être utilisées pour préserver les configurations spécifiques à chaque visite, pour fournir certaines fonctionnalités du Site et pour en savoir plus sur la façon dont les visiteurs utilisent notre Site (nom d’utilisateur, langue et autres paramètres d’affichage). Cette information nous aide à améliorer notre Site et à vous fournir la meilleure expérience utilisateur possible.Tous les logiciels de navigateur Web courants offrent des options pour bloquer et supprimer les cookies de votre ordinateur. Gardez à l\'esprit que le blocage ou la suppression des cookies peut diminuer votre expérience utilisateur ou vous empêcher d\'utiliser certaines fonctionnalités de notre Site.Les cookies analytiques nous permettent d’obtenir des statistiques anonymes de fréquentation de notre site afin de l’optimiser et de détecter d’éventuels dysfonctionnements. Ils sont déposés sur nos sites et applications par les sociétés Google Analytics.Si vous ne souhaitez pas que nos sites et nos services enregistrent des cookies dans votre navigateur à des fins de mesures d’audience, vous pouvez cliquer sur le lien suivant où vous trouverez des informations supplémentaires : Cookies Google Analyticshttps ://tools.google.com/dlpage/gaoptoutNous utilisons la plate-forme Doubleclick pour gérer les affichages publicitaires sur nos sites Internet. Vous pouvez cliquer sur le lien suivant pour gérer les cookies de Doubleclick. https ://www.google.com/settings/u/0/ads/authenticated',

  'PURPOSE_OF_YOUR_DATA_PROCESSING': 'Finalité du traitement de vos données',
  'WE_ONLY_COLLECT_AND_PROCESS': 'Nous ne collectons et traitons vos données que pour les finalités expressément indiquées :',
  'YOUR_CONSENT_TO_RECEIVE_OUR_NEWSLETTERS': 'votre consentement à recevoir nos newsletter,',
  'THE_USE_OF_OUR_SITE_AND_SERVICES': 'l’utilisation de notre Site et des Services permettant la gestion de vos programmes,',
  'the_implementation_of_the_service': 'l’exécution du contrat de service qui nous lie à votre société. ',

  'HOW_LONG_YOUR_DATA_WILL_BE_STORED': 'Durée pendant lesquelles nous conservons vos données',
  'HOW_LONG_YOUR_DATA_WILL_BE_STORED_TEXT':
    'Nous ne conservons vos données que pendant la durée nécessaire à la fourniture des Services auxquels vous avez souscrit. Au-delà, elles ne seront conservées qu’à des fins statistiques, ou dans le cadre d’obligations légales, et ne donneront lieu à aucune exploitation.',

  'TRANSFER_OF_YOUR_DATA': 'Transfert de vos données',
  'TRANSFER_OF_YOUR_DATA_TEXT':
    'Nous conservons vos données personnelles dans l’Union européenne. Toutefois, il est possible de manière marginale qu’elles soient transférées à des sous-traitants ou partenaires commerciaux situés dans d’autres pays. En cas de transfert de ce type, nous nous assurons de ce que le traitement soit effectué conformément à la présente politique de confidentialité et qu’il soit encadré par les clauses contractuelles types de la Commission européenne qui permettent de garantir un niveau de protection suffisant de la vie privée et des droits fondamentaux des personnes.',
  'SECURITY': 'Sécurité',
  'SECURITY_TEXT':
    ' Nous avons recours à des mesures techniques comme le chiffrage ou l’utilisation de mots de passe pour protéger vos données ainsi que les systèmes dans lesquelles elles sont sauvegardées. Nous prenons également des mesures opérationnelles de protection des données comme par exemple en limitant le nombre de personnes ayant accès aux bases de données dans lesquelles les informations relatives aux réservations sont sauvegardées. Nous veillons à ce que ces mesures sécuritaires soient régulièrement révisées et nous nous appuyons sur les normes de sécurité du secteur pour nous tenir informés des meilleures pratiques.Nous appliquons les mêmes exigences sécuritaires à l’égard de nos sous-traitants et partenaires. Nous veillons à ce qu’ils s’engagent contractuellement à prendre les mesures techniques et organisationnelles requises pour protéger les données à caractère personnel contre la destruction accidentelle ou non autorisée, contre la perte accidentelle ainsi que contre la modiﬁcation, l\'accès et tout autre traitement non autorisé de données à caractère personnel.',

  'RIGHTS_OF_ACCESS_AND_RECTIFICATION': 'Rights of access and rectification',
  'RIGHTS_OF_ACCESS_AND_RECTIFICATION_TEXT':
    'Vous pouvez consulter des copies de toutes les données personnelles que nous détenons et demander à modifier, rectifier ou supprimer vos données personnelles. Vous pouvez également limiter, restreindre ou vous opposer au traitement de vos données.Vous pouvez vous connecter sur le Site afin d’actualiser les renseignements qui y figurent.Si vous nous avez donné votre consentement pour que nous puissions utiliser vos données, par exemple, afin de vous envoyer des sollicitations commerciales, vous pourrez retirer directement votre consentement, grâce au lien hypertexte inséré dans le corps de la Newsletter. Nous pouvons toutefois toujours nous appuyer sur le consentement que vous nous avez donné, comme base légale, pour le traitement des données effectué avant le retrait de votre consentement.Pour soulever toute objection ou exercer l’un de vos droits, vous pouvez nous contacter dans les conditions visées à l’article « Réclamations » ci-après.Lorsque vous nous contactez, nous vous répondrons dès que nous serons en mesure de le faire et le cas échéant endéans les deux mois. Si votre demande est complexe, nos délais de réponse risquent d’être allongés, mais nous reviendrons vers vous dans un délai supplémentaire de deux mois maximum. La plupart des demandes seront traitées gratuitement, mais nous sommes susceptibles de vous demander de payer des frais administratifs raisonnables si vous nous demandez, par exemple, une importante quantité de données. Nous pourrons également vous demander de vérifier votre identité avant de pouvoir vous fournir des informations.',

  'CLAIMS': 'Réclamations',
  'CLAIMS_TEXT':
    'Si vous avez des réclamations sur le traitement de vos données personnelles par MCube, veuillez nous adresser un email à support@mcubedigital.com ou bien nous écrire à l’adresse suivante : Data Protection, SPRL Storever Belgium, située Boulevard International 55 à 1070 Anderlecht, Belgique.Veuillez noter que vous avez le droit de déposer plainte auprès d’une autorité de contrôle chargée de la protection des données personnelles dans le pays où vous vivez ou travaillez ou dans celui où vous estimez qu’une violation des lois sur la protection des données pourrait avoir eu lieu.Les clients en Belgique peuvent contacter l’Autorité de Protection des Données en composant le +32 (0)2 274 48 00 ou en utilisant le formulaire en ligne de prise de contact, qui est disponible sur le site Internet de l’Autorité dont l’adresse est www.autoriteprotectiondonnees.be.',
  'Go_BACKOFFICE_MESSAGE': 'Voir sur le backoffice',
  'ERROR_USER_CODE_NOT_FOUND': 'Le token est incorrect ou a expiré, veuillez refaire une demande de récupération de mot de passe.',
  'ERROR_INVALID_PASSWORD': 'Le mot de passe est incorrect ou identique au précédent.',
  'ERROR_USER_EMAIL_NOT_UNIQUE': 'Erreur de multi utilisateurs avec cette adresse e-mail, veuillez contacter l\'équipe de développement',
  'TICKET_LIST_PAGE_TITLE': 'Portal | Tickets',
  'TICKET_DETAILS_PAGE_TITLE': 'Portal | Tickets détails',
  'TICKETS': 'Tickets',
  'TICKETS_LIST_TITLE': 'Tickets',
  'TICKETS_ISSUE_TYPE': 'Type de problème',
  'TICKETS_DESCRIPTION': 'Description',
  'TICKETS_DATE_CREATION': 'Création',
  'TICKETS_DATE_CLOSE': 'clôturer',
  'TICKETS_IS_CLOSE': 'Status ouvert',
  'TICKET_ID': 'Ticket id',
  'TICKET_STATUS_OPENED': 'OUVERT',
  'TICKET_STATUS_CLOSED': 'FERMÉ',
  'PLAYER_SUBSCRIPTION': 'Subscription',
  'TICKET_LIST_FILTER_SUBSCRIPTION': 'Subscription nom',
  'TICKET_INFO_TITLE': 'Ticket info',
  'TICKET_CREATED': 'Créé',
  'TICKET_CLOSED': 'Fermé',
  'TICKET_DEVICE_ID': 'Device id',
  'TICKET_MODEL': 'Device id',
  'TICKET_STATUS': 'Status',
  'SUBSCRIPTION_INFO': 'Subscription info',
  'TODO_INFO': 'Todo info',
  'TODO_TYPE': 'Todo type',
  'TODO_USER_ASSIGN': 'Attribuer à l\'utilisateur',
  'TODO_DESCRIPTION': 'Description',
  'TODO_ACTION': 'Action',
  'TODO_ACTION_DATE': 'Action date',
  'TICKET_ADDRESS': 'Adresse',
  'TICKET_CONTACT': 'Contact',
  'TICKET_LIST_QUICK_SEARCH': 'Recherche rapide par player id , description ou todo ',
  'MUSIC_PREVIEW_TITLE': 'Music Preview',
  'MUSIC_PREVIEW_LIST_PAGE_TITLE': 'Portal | Music Preview',
  'MUSIC_PREVIEW_LINK_MODAL_PAGE_TITLE': 'Link station and boxes to your client',
  'MUSIC_PREVIEW_IMPORT_STATION_DIALOG': 'Stations',
  'MUSIC_PREVIEW_DIALOG_STATION_NONE': '(select a station)',
  'MUSIC_PREVIEW_DIALOG_BOXES_NONE': '(select a box or playlist)',
  'MUSIC_PREVIEW_IMPORT_BOXES_DIALOG_PLAYLIST': 'Boxes and playlist',
  'MUSIC_PREVIEW_DIALOG_CONFIRM': 'Save',
  'AUDIO_PLANNINGS_ARTISTS_NAME': 'Artists',
  'MUSIC_PREVIEW_RATING': 'Rating',
  'AUDIO_PLANNINGS_TITLE': 'Title',
  'AUDIO_PLANNINGS_YEAR': 'Year',
  'BOX_PLAYLIST_LOAD_ERROR': 'Box playlist load error',
  'RATTING_SUCCESS': 'Rating update success',
  'STATIONS_LOAD_ERROR': 'Station success',
  'RATTING_ERROR': 'Rating update error',
  'CREATE_BOX_STATION_CLIENT_SUCCESS': 'Create link between client , station and box success',
  'CREATE_BOX_STATION_CLIENT_ERROR': 'Create link between client , station and box error',
  'TRACK_LIST_BAD_REQUEST_ERROR': 'Track list Bad request',
  'TRACK_LIST_LOAD_ERROR': 'Tracks list load error',
  'ROLE_PORTAL_MUSICPREVIEW': 'Can view music preview',
  'MUSIC_PREVIEW_NO_LINK_MSG_1': 'The preview of music is not planned.',
  'MUSIC_PREVIEW_NO_LINK_MSG_2': 'Please ask your producer to plan preview music.',
  'MUSIC_PREVIEW_NO_RULE_MSG_1': 'You don\'t have enough right.',
  'MUSIC_PREVIEW_NO_RULE_MSG_2': 'Please ask your producer to update your right.',
  'ROLE_BO_SETUP': 'Can Setup Player',
  'ROLE_BO_ORDER': 'Can manage Order',
  'ROLE_BO_CANCLOSESITE': 'Can close site',
  'ROLE_BO_SHIPPING_VIEW': 'Can view shipping',
  'ROLE_BO_BILLING_VIEW': 'Can view  billing',
  'ROLE_BO_BILLING_EDIT': 'Can manage billing',
  'ROLE_BO_SHIPPING_EDIT': 'Can manage shipping',
  'ROLE_BO_PLAYERCONFIG_VIEW': 'Can view Player configuration',
  'ROLE_BO_PLAYERCONFIG_EDIT': 'Can manage Player configuration',
  'ROLE_BO_BILLING_CHANGE_CURRENCY': 'Can change the currency of a contract',
  'ROLE_BO_ORDERCANCEL_PICKED': 'Can cancel an order even if player is picked',
  'ROLE_BO_MANAGER_PLAYER': 'Can manage a player from a subscription',
  'ROLE_BO_BILLING_INVOICES_VIEW': 'Can view invoices',
  'ROLE_BO_BILLING_INVOICES_CREATE': 'Can create invoices',
  'ROLE_BO_BILLING_EXECUTE': 'Can launch billing calculation',
  'ROLE_BO_BILLING_SALES_DASHBOARD_EDIT': 'Can edit content and target in Sales dashboard',
  'ROLE_BO_REPORTING_SUPPORT': 'Can view report support stats',
  'REASON_DONT_LIKE_THE_SONG_TITLE': 'La raison de ne pas aimer la chanson.',
  'REASON_DONT_LIKE_THE_SONG': 'Raison',
  'AUDIO_PLANNINGS_COMMENT': 'Commentaires',
  'SAVE': 'Save',
  'PLAYER_EVENT_LOGS_LAST_ERROR': 'Erreurs trouvées pour aujourd\'hui',
  'PLAYERS_ISSUE_CLIENT_NAME': 'Client',
  'PLAYERS_ISSUE_LIST_TITLE': 'Player issues',
  'PLAYERS_ISSUE_LIST_UPDATED': 'Modifié',
  'PLAYERS_ISSUE_LIST_CREATED': 'Dernière mise à jour',
  'PLAYERS_ISSUE_LIST_CLOSED': 'Clôturer',
  'PLAYERS_ISSUE_LIST_TYPE_ISSUE': 'Type',
  'PLAYERS_ISSUE_LIST_TYPE_DESCRIPTION': 'Description',
  'PLAYERS_ISSUE_LIST_CLIENT': 'Client',
  'PLAYERS_ISSUE_LIST_START_DATE': 'Date de Début ',
  'PLAYERS_ISSUE_LIST_END_DATE': 'Date de fin',
  'PLAYERS_ISSUE_FILTER_START_DATE': 'Date de dernière mise à jour',
  'PLAYERS_ISSUE_FILTER_END_DATE': 'Date de fin',
  'PLAYERS_ISSUE_LIST_QUICK_SEARCH': 'Quick search par site et client',
  'PLAYERS_LIST_ISSUE_QUICK_SEARCH': 'Quick search by subscription',
  'PLAYERS_LIST_FILTER_SUBSCRIPTION': 'Subscription',
  'CREATE_USER_DIALOG_IS_STOREVER': 'Is MCube',
  'ROLE_PORTAL_PLAYERISSUES': 'Can view Player issue',
  'ROLE_PORTAL_ADVANCED_USER_MANAGEMENT': 'Can view advanced user management',
  'PRODUCTION_LINE_BXL': 'Production line Brussels',
  'PRODUCTION_LINE_SHA': 'Production line Shanghai',
  'PRODUCTION_LINE_TRI': 'Production line Trieste',
  'PRODUCTION_LINE_MIL': 'Production line Milano',
  'PRODUCTION_LINE_PAR': 'Production line Paris',
  'PRODUCTION_LINE_EXT': 'External Partners',
  'ROLE_BO_ANOMALIES_MULTIPLEDEFAULT_PLAYER': 'Allow to view anomalies with multi default player',
  'COMMAND_UPDATE': 'Update',
  'COMMAND_REBOOT': 'Reboot',
  'COMMAND_UPGRADE FIRMWARE': 'Upgrade firmware',
  'COMMAND_TAKE SCREENSHOT': 'Take screenshot',
  'PLAYER_SCREENSHOT_TITLE': 'Screenshot',
  'PLAYER_SCREENSHOT_REPORTED_AT': 'Reported at',
  'PLAYER_SCREENSHOT_DIMENSION': 'Dimension',
  'PLAYER_SCREENSHOT_SIZE': 'Size',
  'CLIENT_SERVICE_SERVICE': 'Service',
  'CLIENT_SERVICE_MAINTENANCE': 'Maintenance',
  'CLIENT_SERVICE_HOSTING': 'Hosting',
  'PLAYER_SCREENSHOT_FORMAT': 'Format'
}
